import "./sdk.gen-CV5NlfXb.js";
//#region src/generated/types.gen.ts
var e = { VASCO: "VASCO" }, t = { STATUS: "status" }, n = {
	ACTIVE: "ACTIVE",
	INACTIVE: "INACTIVE"
}, r = {
	ASC: "ASC",
	DESC: "DESC"
}, i = {
	SalesChannelStatusChanged: "SalesChannelStatusChanged",
	ProductCreated: "ProductCreated",
	ProductUpdated: "ProductUpdated",
	OrderAlreadyDiscovered: "OrderAlreadyDiscovered",
	OrderCreated: "OrderCreated",
	OrderDeleted: "OrderDeleted",
	OrderRulesEvaluated: "OrderRulesEvaluated",
	OrderUpdated: "OrderUpdated",
	Printed: "Printed",
	PrintErrored: "PrintErrored"
}, a = {
	Account: "account",
	Shop: "shop",
	Order: "ORDER",
	Product: "PRODUCT",
	Print: "PRINT"
}, o = {
	Event: "Event",
	Order: "Order",
	Printing: "Printing",
	Product: "Product"
};
//#endregion
//#region ../../node_modules/.pnpm/@vue+shared@3.5.41/node_modules/@vue/shared/dist/shared.esm-bundler.js
// @__NO_SIDE_EFFECTS__
function s(e) {
	let t = /* @__PURE__ */ Object.create(null);
	for (let n of e.split(",")) t[n] = 1;
	return (e) => e in t;
}
var c = process.env.NODE_ENV === "production" ? {} : Object.freeze({});
process.env.NODE_ENV === "production" || Object.freeze([]);
var l = () => {}, u = (e) => e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && (e.charCodeAt(2) > 122 || e.charCodeAt(2) < 97), d = (e) => e.startsWith("onUpdate:"), f = Object.assign, p = Object.prototype.hasOwnProperty, m = (e, t) => p.call(e, t), h = Array.isArray, g = (e) => S(e) === "[object Map]", _ = (e) => S(e) === "[object Set]", v = (e) => typeof e == "function", y = (e) => typeof e == "string", b = (e) => typeof e == "symbol", x = (e) => typeof e == "object" && !!e, ee = (e) => (x(e) || v(e)) && v(e.then) && v(e.catch), te = Object.prototype.toString, S = (e) => te.call(e), C = (e) => S(e).slice(8, -1), ne = (e) => S(e) === "[object Object]", re = (e) => y(e) && e !== "NaN" && e[0] !== "-" && "" + parseInt(e, 10) === e, ie = ((e) => {
	let t = /* @__PURE__ */ Object.create(null);
	return ((n) => t[n] || (t[n] = e(n)));
})((e) => e.charAt(0).toUpperCase() + e.slice(1)), ae = (e, t) => !Object.is(e, t), oe = (e, t, n, r = !1) => {
	Object.defineProperty(e, t, {
		configurable: !0,
		enumerable: !1,
		writable: r,
		value: n
	});
}, se, ce = () => se ||= typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {};
function le(e) {
	if (h(e)) {
		let t = {};
		for (let n = 0; n < e.length; n++) {
			let r = e[n], i = y(r) ? pe(r) : le(r);
			if (i) for (let e in i) t[e] = i[e];
		}
		return t;
	}
	if (y(e) || x(e)) return e;
}
var ue = /;(?![^(]*\))/g, de = /:([^]+)/, fe = /\/\*[^]*?\*\//g;
function pe(e) {
	let t = {};
	return e.replace(fe, "").split(ue).forEach((e) => {
		if (e) {
			let n = e.split(de);
			n.length > 1 && (t[n[0].trim()] = n[1].trim());
		}
	}), t;
}
function me(e) {
	let t = "";
	if (y(e)) t = e;
	else if (h(e)) for (let n = 0; n < e.length; n++) {
		let r = me(e[n]);
		r && (t += r + " ");
	}
	else if (x(e)) for (let n in e) e[n] && (t += n + " ");
	return t.trim();
}
//#endregion
//#region ../../node_modules/.pnpm/@vue+reactivity@3.5.41/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
function he(e, ...t) {
	console.warn(`[Vue warn] ${e}`, ...t);
}
var w, ge = /* @__PURE__ */ new WeakSet(), _e = class {
	constructor(e) {
		this.fn = e, this.deps = void 0, this.depsTail = void 0, this.flags = 5, this.next = void 0, this.cleanup = void 0, this.scheduler = void 0;
	}
	pause() {
		this.flags |= 64;
	}
	resume() {
		this.flags & 64 && (this.flags &= -65, ge.has(this) && (ge.delete(this), this.trigger()));
	}
	notify() {
		this.flags & 2 && !(this.flags & 32) || this.flags & 8 || xe(this);
	}
	run() {
		if (!(this.flags & 1)) return this.fn();
		this.flags |= 2, Pe(this), we(this);
		let e = w, t = Ae;
		w = this, Ae = !0;
		try {
			return this.fn();
		} finally {
			process.env.NODE_ENV !== "production" && w !== this && he("Active effect was not restored correctly - this is likely a Vue internal bug."), Te(this), w = e, Ae = t, this.flags &= -3;
		}
	}
	stop() {
		if (this.flags & 1) {
			for (let e = this.deps; e; e = e.nextDep) Oe(e);
			this.deps = this.depsTail = void 0, Pe(this), this.onStop && this.onStop(), this.flags &= -2;
		}
	}
	trigger() {
		this.flags & 64 ? ge.add(this) : this.scheduler ? this.scheduler() : this.runIfDirty();
	}
	runIfDirty() {
		Ee(this) && this.run();
	}
	get dirty() {
		return Ee(this);
	}
}, ve = 0, ye, be;
function xe(e, t = !1) {
	if (e.flags |= 8, t) {
		e.next = be, be = e;
		return;
	}
	e.next = ye, ye = e;
}
function Se() {
	ve++;
}
function Ce() {
	if (--ve > 0) return;
	if (be) {
		let e = be;
		for (be = void 0; e;) {
			let t = e.next;
			e.next = void 0, e.flags &= -9, e = t;
		}
	}
	let e;
	for (; ye;) {
		let t = ye;
		for (ye = void 0; t;) {
			let n = t.next;
			if (t.next = void 0, t.flags &= -9, t.flags & 1) try {
				t.trigger();
			} catch (t) {
				e ||= t;
			}
			t = n;
		}
	}
	if (e) throw e;
}
function we(e) {
	for (let t = e.deps; t; t = t.nextDep) t.version = -1, t.prevActiveLink = t.dep.activeLink, t.dep.activeLink = t;
}
function Te(e) {
	let t, n = e.depsTail, r = n;
	for (; r;) {
		let e = r.prevDep;
		r.version === -1 ? (r === n && (n = e), Oe(r), ke(r)) : t = r, r.dep.activeLink = r.prevActiveLink, r.prevActiveLink = void 0, r = e;
	}
	e.deps = t, e.depsTail = n;
}
function Ee(e) {
	for (let t = e.deps; t; t = t.nextDep) if (t.dep.version !== t.version || t.dep.computed && (De(t.dep.computed) || t.dep.version !== t.version)) return !0;
	return !!e._dirty;
}
function De(e) {
	if (e.flags & 4 && !(e.flags & 16) || (e.flags &= -17, e.globalVersion === Fe) || (e.globalVersion = Fe, !e.isSSR && e.flags & 128 && (!e.deps && !e._dirty || !Ee(e)))) return;
	e.flags |= 2;
	let t = e.dep, n = w, r = Ae;
	w = e, Ae = !0;
	try {
		we(e);
		let n = e.fn(e._value);
		(t.version === 0 || ae(n, e._value)) && (e.flags |= 128, e._value = n, t.version++);
	} catch (e) {
		throw t.version++, e;
	} finally {
		w = n, Ae = r, Te(e), e.flags &= -3;
	}
}
function Oe(e, t = !1) {
	let { dep: n, prevSub: r, nextSub: i } = e;
	if (r && (r.nextSub = i, e.prevSub = void 0), i && (i.prevSub = r, e.nextSub = void 0), process.env.NODE_ENV !== "production" && n.subsHead === e && (n.subsHead = i), n.subs === e && (n.subs = r, !r && n.computed)) {
		n.computed.flags &= -5;
		for (let e = n.computed.deps; e; e = e.nextDep) Oe(e, !0);
	}
	!t && !--n.sc && n.map && n.map.delete(n.key);
}
function ke(e) {
	let { prevDep: t, nextDep: n } = e;
	t && (t.nextDep = n, e.prevDep = void 0), n && (n.prevDep = t, e.nextDep = void 0);
}
var Ae = !0, je = [];
function Me() {
	je.push(Ae), Ae = !1;
}
function Ne() {
	let e = je.pop();
	Ae = e === void 0 || e;
}
function Pe(e) {
	let { cleanup: t } = e;
	if (e.cleanup = void 0, t) {
		let e = w;
		w = void 0;
		try {
			t();
		} finally {
			w = e;
		}
	}
}
var Fe = 0, Ie = class {
	constructor(e, t) {
		this.sub = e, this.dep = t, this.version = t.version, this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
	}
}, Le = class {
	constructor(e) {
		this.computed = e, this.version = 0, this.activeLink = void 0, this.subs = void 0, this.map = void 0, this.key = void 0, this.sc = 0, this.__v_skip = !0, process.env.NODE_ENV !== "production" && (this.subsHead = void 0);
	}
	track(e) {
		if (!w || !Ae || w === this.computed) return;
		let t = this.activeLink;
		if (t === void 0 || t.sub !== w) t = this.activeLink = new Ie(w, this), w.deps ? (t.prevDep = w.depsTail, w.depsTail.nextDep = t, w.depsTail = t) : w.deps = w.depsTail = t, Re(t);
		else if (t.version === -1 && (t.version = this.version, t.nextDep)) {
			let e = t.nextDep;
			e.prevDep = t.prevDep, t.prevDep && (t.prevDep.nextDep = e), t.prevDep = w.depsTail, t.nextDep = void 0, w.depsTail.nextDep = t, w.depsTail = t, w.deps === t && (w.deps = e);
		}
		return process.env.NODE_ENV !== "production" && w.onTrack && w.onTrack(f({ effect: w }, e)), t;
	}
	trigger(e) {
		this.version++, Fe++, this.notify(e);
	}
	notify(e) {
		Se();
		try {
			if (process.env.NODE_ENV !== "production") for (let t = this.subsHead; t; t = t.nextSub) t.sub.onTrigger && !(t.sub.flags & 8) && t.sub.onTrigger(f({ effect: t.sub }, e));
			for (let e = this.subs; e; e = e.prevSub) e.sub.notify() && e.sub.dep.notify();
		} finally {
			Ce();
		}
	}
};
function Re(e) {
	if (e.dep.sc++, e.sub.flags & 4) {
		let t = e.dep.computed;
		if (t && !e.dep.subs) {
			t.flags |= 20;
			for (let e = t.deps; e; e = e.nextDep) Re(e);
		}
		let n = e.dep.subs;
		n !== e && (e.prevSub = n, n && (n.nextSub = e)), process.env.NODE_ENV !== "production" && e.dep.subsHead === void 0 && (e.dep.subsHead = e), e.dep.subs = e;
	}
}
var ze = /* @__PURE__ */ new WeakMap(), Be = /* @__PURE__ */ Symbol(process.env.NODE_ENV === "production" ? "" : "Object iterate"), Ve = /* @__PURE__ */ Symbol(process.env.NODE_ENV === "production" ? "" : "Map keys iterate"), He = /* @__PURE__ */ Symbol(process.env.NODE_ENV === "production" ? "" : "Array iterate");
function T(e, t, n) {
	if (Ae && w) {
		let r = ze.get(e);
		r || ze.set(e, r = /* @__PURE__ */ new Map());
		let i = r.get(n);
		i || (r.set(n, i = new Le()), i.map = r, i.key = n), process.env.NODE_ENV === "production" ? i.track() : i.track({
			target: e,
			type: t,
			key: n
		});
	}
}
function Ue(e, t, n, r, i, a) {
	let o = ze.get(e);
	if (!o) {
		Fe++;
		return;
	}
	let s = (o) => {
		o && (process.env.NODE_ENV === "production" ? o.trigger() : o.trigger({
			target: e,
			type: t,
			key: n,
			newValue: r,
			oldValue: i,
			oldTarget: a
		}));
	};
	if (Se(), t === "clear") o.forEach(s);
	else {
		let i = h(e), a = i && re(n);
		if (i && n === "length") {
			let e = Number(r);
			o.forEach((t, n) => {
				(n === "length" || n === He || !b(n) && n >= e) && s(t);
			});
		} else switch ((n !== void 0 || o.has(void 0)) && s(o.get(n)), a && s(o.get(He)), t) {
			case "add":
				i ? a && s(o.get("length")) : (s(o.get(Be)), g(e) && s(o.get(Ve)));
				break;
			case "delete":
				i || (s(o.get(Be)), g(e) && s(o.get(Ve)));
				break;
			case "set": g(e) && s(o.get(Be));
		}
	}
	Ce();
}
function We(e) {
	let t = /* @__PURE__ */ D(e);
	return t === e ? t : (T(t, "iterate", He), /* @__PURE__ */ E(e) ? t : t.map(Mt));
}
function Ge(e) {
	return T(e = /* @__PURE__ */ D(e), "iterate", He), e;
}
function Ke(e, t) {
	return /* @__PURE__ */ kt(e) ? Nt(/* @__PURE__ */ Ot(e) ? Mt(t) : t) : Mt(t);
}
var qe = {
	__proto__: null,
	[Symbol.iterator]() {
		return Je(this, Symbol.iterator, (e) => Ke(this, e));
	},
	concat(...e) {
		return We(this).concat(...e.map((e) => h(e) ? We(e) : e));
	},
	entries() {
		return Je(this, "entries", (e) => (e[1] = Ke(this, e[1]), e));
	},
	every(e, t) {
		return Xe(this, "every", e, t, void 0, arguments);
	},
	filter(e, t) {
		return Xe(this, "filter", e, t, (e) => e.map((e) => Ke(this, e)), arguments);
	},
	find(e, t) {
		return Xe(this, "find", e, t, (e) => Ke(this, e), arguments);
	},
	findIndex(e, t) {
		return Xe(this, "findIndex", e, t, void 0, arguments);
	},
	findLast(e, t) {
		return Xe(this, "findLast", e, t, (e) => Ke(this, e), arguments);
	},
	findLastIndex(e, t) {
		return Xe(this, "findLastIndex", e, t, void 0, arguments);
	},
	forEach(e, t) {
		return Xe(this, "forEach", e, t, void 0, arguments);
	},
	includes(...e) {
		return Qe(this, "includes", e);
	},
	indexOf(...e) {
		return Qe(this, "indexOf", e);
	},
	join(e) {
		return We(this).join(e);
	},
	lastIndexOf(...e) {
		return Qe(this, "lastIndexOf", e);
	},
	map(e, t) {
		return Xe(this, "map", e, t, void 0, arguments);
	},
	pop() {
		return $e(this, "pop");
	},
	push(...e) {
		return $e(this, "push", e);
	},
	reduce(e, ...t) {
		return Ze(this, "reduce", e, t);
	},
	reduceRight(e, ...t) {
		return Ze(this, "reduceRight", e, t);
	},
	shift() {
		return $e(this, "shift");
	},
	some(e, t) {
		return Xe(this, "some", e, t, void 0, arguments);
	},
	splice(...e) {
		return $e(this, "splice", e);
	},
	toReversed() {
		return We(this).toReversed();
	},
	toSorted(e) {
		return We(this).toSorted(e);
	},
	toSpliced(...e) {
		return We(this).toSpliced(...e);
	},
	unshift(...e) {
		return $e(this, "unshift", e);
	},
	values() {
		return Je(this, "values", (e) => Ke(this, e));
	}
};
function Je(e, t, n) {
	let r = Ge(e), i = r[t]();
	return r !== e && !/* @__PURE__ */ E(e) && (i._next = i.next, i.next = () => {
		let e = i._next();
		return e.done || (e.value = n(e.value)), e;
	}), i;
}
var Ye = Array.prototype;
function Xe(e, t, n, r, i, a) {
	let o = Ge(e), s = o !== e && !/* @__PURE__ */ E(e), c = o[t];
	if (c !== Ye[t]) {
		let t = c.apply(e, a);
		return s ? Mt(t) : t;
	}
	let l = n;
	o !== e && (s ? l = function(t, r) {
		return n.call(this, Ke(e, t), r, e);
	} : n.length > 2 && (l = function(t, r) {
		return n.call(this, t, r, e);
	}));
	let u = c.call(o, l, r);
	return s && i ? i(u) : u;
}
function Ze(e, t, n, r) {
	let i = Ge(e), a = i !== e && !/* @__PURE__ */ E(e), o = n, s = !1;
	i !== e && (a ? (s = r.length === 0, o = function(t, r, i) {
		return s && (s = !1, t = Ke(e, t)), n.call(this, t, Ke(e, r), i, e);
	}) : n.length > 3 && (o = function(t, r, i) {
		return n.call(this, t, r, i, e);
	}));
	let c = i[t](o, ...r);
	return s ? Ke(e, c) : c;
}
function Qe(e, t, n) {
	let r = /* @__PURE__ */ D(e);
	T(r, "iterate", He);
	let i = r[t](...n);
	return (i === -1 || i === !1) && /* @__PURE__ */ At(n[0]) ? (n[0] = /* @__PURE__ */ D(n[0]), r[t](...n)) : i;
}
function $e(e, t, n = []) {
	Me(), Se();
	let r = (/* @__PURE__ */ D(e))[t].apply(e, n);
	return Ce(), Ne(), r;
}
var et = /* @__PURE__ */ s("__proto__,__v_isRef,__isVue"), tt = new Set(/* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((e) => e !== "arguments" && e !== "caller").map((e) => Symbol[e]).filter(b));
function nt(e) {
	b(e) || (e = String(e));
	let t = /* @__PURE__ */ D(this);
	return T(t, "has", e), t.hasOwnProperty(e);
}
var rt = class {
	constructor(e = !1, t = !1) {
		this._isReadonly = e, this._isShallow = t;
	}
	get(e, t, n) {
		if (t === "__v_skip") return e.__v_skip;
		let r = this._isReadonly, i = this._isShallow;
		if (t === "__v_isReactive") return !r;
		if (t === "__v_isReadonly") return r;
		if (t === "__v_isShallow") return i;
		if (t === "__v_raw") return n === (r ? i ? St : xt : i ? bt : yt).get(e) || Object.getPrototypeOf(e) === Object.getPrototypeOf(n) ? e : void 0;
		let a = h(e);
		if (!r) {
			let e;
			if (a && (e = qe[t])) return e;
			if (t === "hasOwnProperty") return nt;
		}
		let o = Reflect.get(e, t, /* @__PURE__ */ O(e) ? e : n);
		if ((b(t) ? tt.has(t) : et(t)) || (r || T(e, "get", t), i)) return o;
		if (/* @__PURE__ */ O(o)) {
			let e = a && re(t) ? o : o.value;
			return r && x(e) ? /* @__PURE__ */ Tt(e) : e;
		}
		return x(o) ? r ? /* @__PURE__ */ Tt(o) : /* @__PURE__ */ wt(o) : o;
	}
}, it = class extends rt {
	constructor(e = !1) {
		super(!1, e);
	}
	set(e, t, n, r) {
		let i = e[t], a = h(e) && re(t);
		if (!this._isShallow) {
			let r = /* @__PURE__ */ kt(i);
			if (!/* @__PURE__ */ E(n) && !/* @__PURE__ */ kt(n) && (i = /* @__PURE__ */ D(i), n = /* @__PURE__ */ D(n)), !a && /* @__PURE__ */ O(i) && !/* @__PURE__ */ O(n)) return r ? (process.env.NODE_ENV !== "production" && he(`Set operation on key "${String(t)}" failed: target is readonly.`, e[t]), !0) : (i.value = n, !0);
		}
		let o = a ? Number(t) < e.length : m(e, t), s = Reflect.set(e, t, n, /* @__PURE__ */ O(e) ? e : r);
		return e === /* @__PURE__ */ D(r) && s && (o ? ae(n, i) && Ue(e, "set", t, n, i) : Ue(e, "add", t, n)), s;
	}
	deleteProperty(e, t) {
		let n = m(e, t), r = e[t], i = Reflect.deleteProperty(e, t);
		return i && n && Ue(e, "delete", t, void 0, r), i;
	}
	has(e, t) {
		let n = Reflect.has(e, t);
		return (!b(t) || !tt.has(t)) && T(e, "has", t), n;
	}
	ownKeys(e) {
		return T(e, "iterate", h(e) ? "length" : Be), Reflect.ownKeys(e);
	}
}, at = class extends rt {
	constructor(e = !1) {
		super(!0, e);
	}
	set(e, t) {
		return process.env.NODE_ENV !== "production" && he(`Set operation on key "${String(t)}" failed: target is readonly.`, e), !0;
	}
	deleteProperty(e, t) {
		return process.env.NODE_ENV !== "production" && he(`Delete operation on key "${String(t)}" failed: target is readonly.`, e), !0;
	}
}, ot = /* @__PURE__ */ new it(), st = /* @__PURE__ */ new at(), ct = /* @__PURE__ */ new at(!0), lt = (e) => e, ut = (e) => Reflect.getPrototypeOf(e);
function dt(e, t, n) {
	return function(...r) {
		let i = this.__v_raw, a = /* @__PURE__ */ D(i), o = g(a), s = e === "entries" || e === Symbol.iterator && o, c = e === "keys" && o, l = i[e](...r), u = n ? lt : t ? Nt : Mt;
		return !t && T(a, "iterate", c ? Ve : Be), f(Object.create(l), { next() {
			let { value: e, done: t } = l.next();
			return t ? {
				value: e,
				done: t
			} : {
				value: s ? [u(e[0]), u(e[1])] : u(e),
				done: t
			};
		} });
	};
}
function ft(e) {
	return function(...t) {
		if (process.env.NODE_ENV !== "production") {
			let n = t[0] ? `on key "${t[0]}" ` : "";
			he(`${ie(e)} operation ${n}failed: target is readonly.`, /* @__PURE__ */ D(this));
		}
		return e === "delete" ? !1 : e === "clear" ? void 0 : this;
	};
}
function pt(e, t) {
	let n = {
		get(n) {
			let r = this.__v_raw, i = /* @__PURE__ */ D(r), a = /* @__PURE__ */ D(n);
			e || (ae(n, a) && T(i, "get", n), T(i, "get", a));
			let { has: o } = ut(i), s = t ? lt : e ? Nt : Mt;
			if (o.call(i, n)) return s(r.get(n));
			if (o.call(i, a)) return s(r.get(a));
			r !== i && r.get(n);
		},
		get size() {
			let t = this.__v_raw;
			return !e && T(/* @__PURE__ */ D(t), "iterate", Be), t.size;
		},
		has(t) {
			let n = this.__v_raw, r = /* @__PURE__ */ D(n), i = /* @__PURE__ */ D(t);
			return e || (ae(t, i) && T(r, "has", t), T(r, "has", i)), t === i ? n.has(t) : n.has(t) || n.has(i);
		},
		forEach(n, r) {
			let i = this, a = i.__v_raw, o = /* @__PURE__ */ D(a), s = t ? lt : e ? Nt : Mt;
			return !e && T(o, "iterate", Be), a.forEach((e, t) => n.call(r, s(e), s(t), i));
		}
	};
	return f(n, e ? {
		add: ft("add"),
		set: ft("set"),
		delete: ft("delete"),
		clear: ft("clear")
	} : {
		add(e) {
			let n = /* @__PURE__ */ D(this), r = ut(n), i = /* @__PURE__ */ D(e), a = !t && !/* @__PURE__ */ E(e) && !/* @__PURE__ */ kt(e) ? i : e;
			return r.has.call(n, a) || ae(e, a) && r.has.call(n, e) || ae(i, a) && r.has.call(n, i) || (n.add(a), Ue(n, "add", a, a)), this;
		},
		set(e, n) {
			!t && !/* @__PURE__ */ E(n) && !/* @__PURE__ */ kt(n) && (n = /* @__PURE__ */ D(n));
			let r = /* @__PURE__ */ D(this), { has: i, get: a } = ut(r), o = i.call(r, e);
			o ? process.env.NODE_ENV !== "production" && vt(r, i, e) : (e = /* @__PURE__ */ D(e), o = i.call(r, e));
			let s = a.call(r, e);
			return r.set(e, n), o ? ae(n, s) && Ue(r, "set", e, n, s) : Ue(r, "add", e, n), this;
		},
		delete(e) {
			let t = /* @__PURE__ */ D(this), { has: n, get: r } = ut(t), i = n.call(t, e);
			i ? process.env.NODE_ENV !== "production" && vt(t, n, e) : (e = /* @__PURE__ */ D(e), i = n.call(t, e));
			let a = r ? r.call(t, e) : void 0, o = t.delete(e);
			return i && Ue(t, "delete", e, void 0, a), o;
		},
		clear() {
			let e = /* @__PURE__ */ D(this), t = e.size !== 0, n = process.env.NODE_ENV === "production" ? void 0 : g(e) ? new Map(e) : new Set(e), r = e.clear();
			return t && Ue(e, "clear", void 0, void 0, n), r;
		}
	}), [
		"keys",
		"values",
		"entries",
		Symbol.iterator
	].forEach((r) => {
		n[r] = dt(r, e, t);
	}), n;
}
function mt(e, t) {
	let n = pt(e, t);
	return (t, r, i) => r === "__v_isReactive" ? !e : r === "__v_isReadonly" ? e : r === "__v_raw" ? t : Reflect.get(m(n, r) && r in t ? n : t, r, i);
}
var ht = { get: /* @__PURE__ */ mt(!1, !1) }, gt = { get: /* @__PURE__ */ mt(!0, !1) }, _t = { get: /* @__PURE__ */ mt(!0, !0) };
function vt(e, t, n) {
	let r = /* @__PURE__ */ D(n);
	if (r !== n && t.call(e, r)) {
		let t = C(e);
		he(`Reactive ${t} contains both the raw and reactive versions of the same object${t === "Map" ? " as keys" : ""}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
	}
}
var yt = /* @__PURE__ */ new WeakMap(), bt = /* @__PURE__ */ new WeakMap(), xt = /* @__PURE__ */ new WeakMap(), St = /* @__PURE__ */ new WeakMap();
function Ct(e) {
	switch (e) {
		case "Object":
		case "Array": return 1;
		case "Map":
		case "Set":
		case "WeakMap":
		case "WeakSet": return 2;
		default: return 0;
	}
}
// @__NO_SIDE_EFFECTS__
function wt(e) {
	return /* @__PURE__ */ kt(e) ? e : Dt(e, !1, ot, ht, yt);
}
// @__NO_SIDE_EFFECTS__
function Tt(e) {
	return Dt(e, !0, st, gt, xt);
}
// @__NO_SIDE_EFFECTS__
function Et(e) {
	return Dt(e, !0, ct, _t, St);
}
function Dt(e, t, n, r, i) {
	if (!x(e)) return process.env.NODE_ENV !== "production" && he(`value cannot be made ${t ? "readonly" : "reactive"}: ${String(e)}`), e;
	if (e.__v_raw && !(t && e.__v_isReactive) || e.__v_skip || !Object.isExtensible(e)) return e;
	let a = i.get(e);
	if (a) return a;
	let o = Ct(C(e));
	if (o === 0) return e;
	let s = new Proxy(e, o === 2 ? r : n);
	return i.set(e, s), s;
}
// @__NO_SIDE_EFFECTS__
function Ot(e) {
	return /* @__PURE__ */ kt(e) ? /* @__PURE__ */ Ot(e.__v_raw) : !!(e && e.__v_isReactive);
}
// @__NO_SIDE_EFFECTS__
function kt(e) {
	return !!(e && e.__v_isReadonly);
}
// @__NO_SIDE_EFFECTS__
function E(e) {
	return !!(e && e.__v_isShallow);
}
// @__NO_SIDE_EFFECTS__
function At(e) {
	return e ? !!e.__v_raw : !1;
}
// @__NO_SIDE_EFFECTS__
function D(e) {
	let t = e && e.__v_raw;
	return t ? /* @__PURE__ */ D(t) : e;
}
function jt(e) {
	return !m(e, "__v_skip") && Object.isExtensible(e) && oe(e, "__v_skip", !0), e;
}
var Mt = (e) => x(e) ? /* @__PURE__ */ wt(e) : e, Nt = (e) => x(e) ? /* @__PURE__ */ Tt(e) : e;
// @__NO_SIDE_EFFECTS__
function O(e) {
	return e ? e.__v_isRef === !0 : !1;
}
function Pt(e) {
	return /* @__PURE__ */ O(e) ? e.value : e;
}
var Ft = {
	get: (e, t, n) => t === "__v_raw" ? e : Pt(Reflect.get(e, t, n)),
	set: (e, t, n, r) => {
		let i = e[t];
		return /* @__PURE__ */ O(i) && !/* @__PURE__ */ O(n) ? (i.value = n, !0) : Reflect.set(e, t, n, r);
	}
};
function It(e) {
	return /* @__PURE__ */ Ot(e) ? e : new Proxy(e, Ft);
}
var Lt = {}, Rt = /* @__PURE__ */ new WeakMap(), zt = void 0;
function Bt(e, t = !1, n = zt) {
	if (n) {
		let t = Rt.get(n);
		t || Rt.set(n, t = []), t.push(e);
	} else process.env.NODE_ENV !== "production" && !t && he("onWatcherCleanup() was called when there was no active watcher to associate with.");
}
function Vt(e, t, n = c) {
	let { immediate: r, deep: i, once: a, scheduler: o, augmentJob: s, call: u } = n, d = (e) => {
		(n.onWarn || he)("Invalid watch source: ", e, "A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.");
	}, f = (e) => i ? e : /* @__PURE__ */ E(e) || i === !1 || i === 0 ? Ht(e, 1) : Ht(e), p, m, g, _, y = !1, b = !1;
	if (/* @__PURE__ */ O(e) ? (m = () => e.value, y = /* @__PURE__ */ E(e)) : /* @__PURE__ */ Ot(e) ? (m = () => f(e), y = !0) : h(e) ? (b = !0, y = e.some((e) => /* @__PURE__ */ Ot(e) || /* @__PURE__ */ E(e)), m = () => e.map((e) => {
		if (/* @__PURE__ */ O(e)) return e.value;
		if (/* @__PURE__ */ Ot(e)) return f(e);
		if (v(e)) return u ? u(e, 2) : e();
		process.env.NODE_ENV !== "production" && d(e);
	})) : v(e) ? m = t ? u ? () => u(e, 2) : e : () => {
		if (g) {
			Me();
			try {
				g();
			} finally {
				Ne();
			}
		}
		let t = zt;
		zt = p;
		try {
			return u ? u(e, 3, [_]) : e(_);
		} finally {
			zt = t;
		}
	} : (m = l, process.env.NODE_ENV !== "production" && d(e)), t && i) {
		let e = m, t = i === !0 ? Infinity : i;
		m = () => Ht(e(), t);
	}
	let x = () => {
		p.stop();
	};
	if (a && t) {
		let e = t;
		t = (...t) => {
			let n = e(...t);
			return x(), n;
		};
	}
	let ee = b ? Array(e.length).fill(Lt) : Lt, te = (e) => {
		if (!(!(p.flags & 1) || !p.dirty && !e)) {
			if (t) {
				let n = p.run();
				if (e || i || y || (b ? n.some((e, t) => ae(e, ee[t])) : ae(n, ee))) {
					g && g();
					let e = zt;
					zt = p;
					try {
						let e = [
							n,
							ee === Lt ? void 0 : b && ee[0] === Lt ? [] : ee,
							_
						];
						ee = n, u ? u(t, 3, e) : t(...e);
					} finally {
						zt = e;
					}
				}
			} else p.run();
		}
	};
	return s && s(te), p = new _e(m), p.scheduler = o ? () => o(te, !1) : te, _ = (e) => Bt(e, !1, p), g = p.onStop = () => {
		let e = Rt.get(p);
		if (e) {
			if (u) u(e, 4);
			else for (let t of e) t();
			Rt.delete(p);
		}
	}, process.env.NODE_ENV !== "production" && (p.onTrack = n.onTrack, p.onTrigger = n.onTrigger), t ? r ? te(!0) : ee = p.run() : o ? o(te.bind(null, !0), !0) : p.run(), x.pause = p.pause.bind(p), x.resume = p.resume.bind(p), x.stop = x, x;
}
function Ht(e, t = Infinity, n) {
	if (t <= 0 || !x(e) || e.__v_skip || (n ||= /* @__PURE__ */ new Map(), (n.get(e) || 0) >= t)) return e;
	if (n.set(e, t), t--, /* @__PURE__ */ O(e)) Ht(e.value, t, n);
	else if (h(e)) for (let r = 0; r < e.length; r++) Ht(e[r], t, n);
	else if (_(e) || g(e)) e.forEach((e) => {
		Ht(e, t, n);
	});
	else if (ne(e)) {
		for (let r in e) Ht(e[r], t, n);
		for (let r of Object.getOwnPropertySymbols(e)) Object.prototype.propertyIsEnumerable.call(e, r) && Ht(e[r], t, n);
	}
	return e;
}
//#endregion
//#region ../../node_modules/.pnpm/@vue+runtime-core@3.5.41/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js
var Ut = [];
function Wt(e) {
	Ut.push(e);
}
function Gt() {
	Ut.pop();
}
var Kt = !1;
function k(e, ...t) {
	if (Kt) return;
	Kt = !0, Me();
	let n = Ut.length ? Ut[Ut.length - 1].component : null, r = n && n.appContext.config.warnHandler, i = qt();
	if (r) $t(r, n, 11, [
		e + t.map((e) => e.toString?.call(e) ?? JSON.stringify(e)).join(""),
		n && n.proxy,
		i.map(({ vnode: e }) => `at <${Nr(n, e.type)}>`).join("\n"),
		i
	]);
	else {
		let n = [`[Vue warn]: ${e}`, ...t];
		i.length && n.push("\n", ...Jt(i)), console.warn(...n);
	}
	Ne(), Kt = !1;
}
function qt() {
	let e = Ut[Ut.length - 1];
	if (!e) return [];
	let t = [];
	for (; e;) {
		let n = t[0];
		n && n.vnode === e ? n.recurseCount++ : t.push({
			vnode: e,
			recurseCount: 0
		});
		let r = e.component && e.component.parent;
		e = r && r.vnode;
	}
	return t;
}
function Jt(e) {
	let t = [];
	return e.forEach((e, n) => {
		t.push(...n === 0 ? [] : ["\n"], ...Yt(e));
	}), t;
}
function Yt({ vnode: e, recurseCount: t }) {
	let n = t > 0 ? `... (${t} recursive calls)` : "", r = e.component ? e.component.parent == null : !1, i = ` at <${Nr(e.component, e.type, r)}`, a = ">" + n;
	return e.props ? [
		i,
		...Xt(e.props),
		a
	] : [i + a];
}
function Xt(e) {
	let t = [], n = Object.keys(e);
	return n.slice(0, 3).forEach((n) => {
		t.push(...Zt(n, e[n]));
	}), n.length > 3 && t.push(" ..."), t;
}
function Zt(e, t, n) {
	return y(t) ? (t = JSON.stringify(t), n ? t : [`${e}=${t}`]) : typeof t == "number" || typeof t == "boolean" || t == null ? n ? t : [`${e}=${t}`] : /* @__PURE__ */ O(t) ? (t = Zt(e, /* @__PURE__ */ D(t.value), !0), n ? t : [
		`${e}=Ref<`,
		t,
		">"
	]) : v(t) ? [`${e}=fn${t.name ? `<${t.name}>` : ""}`] : (t = /* @__PURE__ */ D(t), n ? t : [`${e}=`, t]);
}
var Qt = {
	sp: "serverPrefetch hook",
	bc: "beforeCreate hook",
	c: "created hook",
	bm: "beforeMount hook",
	m: "mounted hook",
	bu: "beforeUpdate hook",
	u: "updated",
	bum: "beforeUnmount hook",
	um: "unmounted hook",
	a: "activated hook",
	da: "deactivated hook",
	ec: "errorCaptured hook",
	rtc: "renderTracked hook",
	rtg: "renderTriggered hook",
	0: "setup function",
	1: "render function",
	2: "watcher getter",
	3: "watcher callback",
	4: "watcher cleanup function",
	5: "native event handler",
	6: "component event handler",
	7: "vnode hook",
	8: "directive hook",
	9: "transition hook",
	10: "app errorHandler",
	11: "app warnHandler",
	12: "ref function",
	13: "async component loader",
	14: "scheduler flush",
	15: "component update",
	16: "app unmount cleanup function"
};
function $t(e, t, n, r) {
	try {
		return r ? e(...r) : e();
	} catch (e) {
		tn(e, t, n);
	}
}
function en(e, t, n, r) {
	if (v(e)) {
		let i = $t(e, t, n, r);
		return i && ee(i) && i.catch((e) => {
			tn(e, t, n);
		}), i;
	}
	if (h(e)) {
		let i = [];
		for (let a = 0; a < e.length; a++) i.push(en(e[a], t, n, r));
		return i;
	}
	process.env.NODE_ENV !== "production" && k(`Invalid value type passed to callWithAsyncErrorHandling(): ${typeof e}`);
}
function tn(e, t, n, r = !0) {
	let i = t ? t.vnode : null, { errorHandler: a, throwUnhandledErrorInProduction: o } = t && t.appContext.config || c;
	if (t) {
		let r = t.parent, i = t.proxy, o = process.env.NODE_ENV === "production" ? `https://vuejs.org/error-reference/#runtime-${n}` : Qt[n];
		for (; r;) {
			let t = r.ec;
			if (t) {
				for (let n = 0; n < t.length; n++) if (t[n](e, i, o) === !1) return;
			}
			r = r.parent;
		}
		if (a) {
			Me(), $t(a, null, 10, [
				e,
				i,
				o
			]), Ne();
			return;
		}
	}
	nn(e, n, i, r, o);
}
function nn(e, t, n, r = !0, i = !1) {
	if (process.env.NODE_ENV !== "production") {
		let i = Qt[t];
		if (n && Wt(n), k(`Unhandled error${i ? ` during execution of ${i}` : ""}`), n && Gt(), r) throw e;
		console.error(e);
	} else if (i) throw e;
	else console.error(e);
}
var A = [], rn = -1, an = [], on = null, sn = 0, cn = /* @__PURE__ */ Promise.resolve(), ln = null, un = 100;
function dn(e) {
	let t = ln || cn;
	return e ? t.then(this ? e.bind(this) : e) : t;
}
function fn(e) {
	let t = rn + 1, n = A.length;
	for (; t < n;) {
		let r = t + n >>> 1, i = A[r], a = _n(i);
		a < e || a === e && i.flags & 2 ? t = r + 1 : n = r;
	}
	return t;
}
function pn(e) {
	if (!(e.flags & 1)) {
		let t = _n(e), n = A[A.length - 1];
		!n || !(e.flags & 2) && t >= _n(n) ? A.push(e) : A.splice(fn(t), 0, e), e.flags |= 1, mn();
	}
}
function mn() {
	ln ||= cn.then(vn);
}
function hn(e) {
	if (!h(e)) on && e.id === -1 ? on.splice(sn + 1, 0, e) : e.flags & 1 || (an.push(e), e.flags |= 1);
	else for (let t = 0; t < e.length; t++) an.push(e[t]);
	mn();
}
function gn(e) {
	if (an.length) {
		let t = [...new Set(an)].sort((e, t) => _n(e) - _n(t));
		if (an.length = 0, on) {
			for (let e = 0; e < t.length; e++) on.push(t[e]);
			return;
		}
		for (on = t, process.env.NODE_ENV !== "production" && (e ||= /* @__PURE__ */ new Map()), sn = 0; sn < on.length; sn++) {
			let t = on[sn];
			process.env.NODE_ENV !== "production" && yn(e, t) || (t.flags & 4 && (t.flags &= -2), t.flags & 8 || t(), t.flags &= -2);
		}
		on = null, sn = 0;
	}
}
var _n = (e) => e.id == null ? e.flags & 2 ? -1 : Infinity : e.id;
function vn(e) {
	process.env.NODE_ENV !== "production" && (e ||= /* @__PURE__ */ new Map());
	let t = process.env.NODE_ENV === "production" ? l : (t) => yn(e, t);
	try {
		for (rn = 0; rn < A.length; rn++) {
			let e = A[rn];
			if (e && !(e.flags & 8)) {
				if (process.env.NODE_ENV !== "production" && t(e)) continue;
				e.flags & 4 && (e.flags &= -2), $t(e, e.i, e.i ? 15 : 14), e.flags & 4 || (e.flags &= -2);
			}
		}
	} finally {
		for (; rn < A.length; rn++) {
			let e = A[rn];
			e && (e.flags &= -2);
		}
		rn = -1, A.length = 0, gn(e), ln = null, (A.length || an.length) && vn(e);
	}
}
function yn(e, t) {
	let n = e.get(t) || 0;
	if (n > un) {
		let e = t.i, n = e && Mr(e.type);
		return tn(`Maximum recursive updates exceeded${n ? ` in component <${n}>` : ""}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`, null, 10), !0;
	}
	return e.set(t, n + 1), !1;
}
var bn = /* @__PURE__ */ new Map();
process.env.NODE_ENV !== "production" && (ce().__VUE_HMR_RUNTIME__ = {
	createRecord: Dn(Sn),
	rerender: Dn(wn),
	reload: Dn(Tn)
});
var xn = /* @__PURE__ */ new Map();
function Sn(e, t) {
	return !xn.has(e) && (xn.set(e, {
		initialDef: Cn(t),
		instances: /* @__PURE__ */ new Set()
	}), !0);
}
function Cn(e) {
	return Pr(e) ? e.__vccOpts : e;
}
function wn(e, t) {
	let n = xn.get(e);
	n && (n.initialDef.render = t, [...n.instances].forEach((e) => {
		t && (e.render = t, Cn(e.type).render = t), e.renderCache = [], e.job.flags & 8 || e.update();
	}));
}
function Tn(e, t) {
	let n = xn.get(e);
	if (!n) return;
	t = Cn(t), En(n.initialDef, t);
	let r = [...n.instances];
	for (let e = 0; e < r.length; e++) {
		let i = r[e], a = Cn(i.type), o = bn.get(a);
		o || (a !== n.initialDef && En(a, t), bn.set(a, o = /* @__PURE__ */ new Set())), o.add(i), i.appContext.propsCache.delete(i.type), i.appContext.emitsCache.delete(i.type), i.appContext.optionsCache.delete(i.type), i.ceReload ? (o.add(i), i.ceReload(t.styles), o.delete(i)) : i.parent ? pn(() => {
			i.job.flags & 8 || (i.parent.update(), o.delete(i));
		}) : i.appContext.reload ? i.appContext.reload() : typeof window < "u" ? window.location.reload() : console.warn("[HMR] Root or manually mounted instance modified. Full reload required."), i.root.ce && i !== i.root && i.root.ce._removeChildStyle(a);
	}
	hn(() => {
		bn.clear();
	});
}
function En(e, t) {
	f(e, t);
	for (let n in e) n !== "__file" && !(n in t) && delete e[n];
}
function Dn(e) {
	return (t, n) => {
		try {
			return e(t, n);
		} catch (e) {
			console.error(e), console.warn("[HMR] Something went wrong during Vue component hot-reload. Full reload required.");
		}
	};
}
var On = null, kn = null;
function An(e, t, n = !1) {
	let r = wr();
	if (r || er) {
		let i = er ? er._context.provides : r ? r.parent == null || r.ce ? r.vnode.appContext && r.vnode.appContext.provides : r.parent.provides : void 0;
		if (i && e in i) return i[e];
		if (arguments.length > 1) return n && v(t) ? t.call(r && r.proxy) : t;
		process.env.NODE_ENV !== "production" && k(`injection "${String(e)}" not found.`);
	} else process.env.NODE_ENV !== "production" && k("inject() can only be used inside setup() or functional components.");
}
var jn = /* @__PURE__ */ Symbol.for("v-scx"), Mn = () => {
	{
		let e = An(jn);
		return e || process.env.NODE_ENV !== "production" && k("Server rendering context not provided. Make sure to only call useSSRContext() conditionally in the server build."), e;
	}
};
function Nn(e, t, n = c) {
	let { immediate: r, deep: i, flush: a, once: o } = n;
	process.env.NODE_ENV !== "production" && !t && (r !== void 0 && k("watch() \"immediate\" option is only respected when using the watch(source, callback, options?) signature."), i !== void 0 && k("watch() \"deep\" option is only respected when using the watch(source, callback, options?) signature."), o !== void 0 && k("watch() \"once\" option is only respected when using the watch(source, callback, options?) signature."));
	let s = f({}, n);
	process.env.NODE_ENV !== "production" && (s.onWarn = k);
	let u = t && r || !t && a !== "post", d;
	if (Or) {
		if (a === "sync") {
			let e = Mn();
			d = e.__watcherHandles ||= [];
		} else if (!u) {
			let e = () => {};
			return e.stop = l, e.resume = l, e.pause = l, e;
		}
	}
	let p = Cr;
	s.call = (e, t, n) => en(e, p, t, n);
	let m = !1;
	a === "post" ? s.scheduler = (e) => {
		rr(e, p && p.suspense);
	} : a !== "sync" && (m = !0, s.scheduler = (e, t) => {
		t ? e() : pn(e);
	}), s.augmentJob = (e) => {
		t && (e.flags |= 4), m && (e.flags |= 2, p && (e.id = p.uid, e.i = p));
	};
	let h = Vt(e, t, s);
	return Or && (d ? d.push(h) : u && h()), h;
}
function Pn(e, t, n) {
	let r = this.proxy, i = y(e) ? e.includes(".") ? Fn(r, e) : () => r[e] : e.bind(r, r), a;
	v(t) ? a = t : (a = t.handler, n = t);
	let o = Er(this), s = Nn(i, a.bind(r), n);
	return o(), s;
}
function Fn(e, t) {
	let n = t.split(".");
	return () => {
		let t = e;
		for (let e = 0; e < n.length && t; e++) t = t[n[e]];
		return t;
	};
}
var In = (e) => e.__isTeleport;
function Ln(e) {
	let t = e[0];
	if (e.length > 1) {
		let n = !1;
		for (let r of e) if (r.type !== cr) {
			if (process.env.NODE_ENV !== "production" && n) {
				k("<transition> can only be used on a single element or component. Use <transition-group> for lists.");
				break;
			}
			if (t = r, n = !0, process.env.NODE_ENV === "production") break;
		}
	}
	return t;
}
function Rn(e) {
	if (!Bn(e)) return In(e.type) && e.children ? Ln(e.children) : e;
	if (e.component) return e.component.subTree;
	let { shapeFlag: t, children: n } = e;
	if (n) {
		if (t & 16) return n[0];
		if (t & 32 && v(n.default)) return n.default();
	}
}
function zn(e, t) {
	if (e.shapeFlag & 6 && e.component) {
		e.transition = t;
		let n = e.component.subTree;
		zn(In(n.type) && Rn(n) || n, t);
	} else e.shapeFlag & 128 ? (e.ssContent.transition = t.clone(e.ssContent), e.ssFallback.transition = t.clone(e.ssFallback)) : e.transition = t;
}
ce().requestIdleCallback, ce().cancelIdleCallback;
var Bn = (e) => e.type.__isKeepAlive, Vn = /* @__PURE__ */ Symbol.for("v-ndc"), Hn = (e) => e ? Dr(e) ? kr(e) : Hn(e.parent) : null, Un = /* @__PURE__ */ f(/* @__PURE__ */ Object.create(null), {
	$: (e) => e,
	$el: (e) => e.vnode.el,
	$data: (e) => e.data,
	$props: (e) => process.env.NODE_ENV === "production" ? e.props : /* @__PURE__ */ Et(e.props),
	$attrs: (e) => process.env.NODE_ENV === "production" ? e.attrs : /* @__PURE__ */ Et(e.attrs),
	$slots: (e) => process.env.NODE_ENV === "production" ? e.slots : /* @__PURE__ */ Et(e.slots),
	$refs: (e) => process.env.NODE_ENV === "production" ? e.refs : /* @__PURE__ */ Et(e.refs),
	$parent: (e) => Hn(e.parent),
	$root: (e) => Hn(e.root),
	$host: (e) => e.ce,
	$emit: (e) => e.emit,
	$options: (e) => __VUE_OPTIONS_API__ ? Gn(e) : e.type,
	$forceUpdate: (e) => e.f ||= () => {
		pn(e.update);
	},
	$nextTick: (e) => e.n ||= dn.bind(e.proxy),
	$watch: (e) => __VUE_OPTIONS_API__ ? Pn.bind(e) : l
});
process.env.NODE_ENV;
function Wn(e) {
	return h(e) ? e.reduce((e, t) => (e[t] = null, e), {}) : e;
}
function Gn(e) {
	let t = e.type, { mixins: n, extends: r } = t, { mixins: i, optionsCache: a, config: { optionMergeStrategies: o } } = e.appContext, s = a.get(t), c;
	return s ? c = s : !i.length && !n && !r ? c = t : (c = {}, i.length && i.forEach((e) => Kn(c, e, o, !0)), Kn(c, t, o)), x(t) && a.set(t, c), c;
}
function Kn(e, t, n, r = !1) {
	let { mixins: i, extends: a } = t;
	a && Kn(e, a, n, !0), i && i.forEach((t) => Kn(e, t, n, !0));
	for (let i in t) if (r && i === "expose") process.env.NODE_ENV !== "production" && k("\"expose\" option is ignored when declared in mixins or extends. It should only be declared in the base component itself.");
	else {
		let r = qn[i] || n && n[i];
		e[i] = r ? r(e[i], t[i]) : t[i];
	}
	return e;
}
var qn = {
	data: Jn,
	props: Qn,
	emits: Qn,
	methods: Zn,
	computed: Zn,
	beforeCreate: j,
	created: j,
	beforeMount: j,
	mounted: j,
	beforeUpdate: j,
	updated: j,
	beforeDestroy: j,
	beforeUnmount: j,
	destroyed: j,
	unmounted: j,
	activated: j,
	deactivated: j,
	errorCaptured: j,
	serverPrefetch: j,
	components: Zn,
	directives: Zn,
	watch: $n,
	provide: Jn,
	inject: Yn
};
function Jn(e, t) {
	return t ? e ? function() {
		return f(v(e) ? e.call(this, this) : e, v(t) ? t.call(this, this) : t);
	} : t : e;
}
function Yn(e, t) {
	return Zn(Xn(e), Xn(t));
}
function Xn(e) {
	if (h(e)) {
		let t = {};
		for (let n = 0; n < e.length; n++) t[e[n]] = e[n];
		return t;
	}
	return e;
}
function j(e, t) {
	return e ? [...new Set([].concat(e, t))] : t;
}
function Zn(e, t) {
	return e ? f(/* @__PURE__ */ Object.create(null), e, t) : t;
}
function Qn(e, t) {
	return e ? h(e) && h(t) ? [.../* @__PURE__ */ new Set([...e, ...t])] : f(/* @__PURE__ */ Object.create(null), Wn(e), Wn(t ?? {})) : t;
}
function $n(e, t) {
	if (!e) return t;
	if (!t) return e;
	let n = f(/* @__PURE__ */ Object.create(null), e);
	for (let r in t) n[r] = j(e[r], t[r]);
	return n;
}
var er = null, tr = {}, nr = (e) => Object.getPrototypeOf(e) === tr, rr = ar, ir = (e) => e.__isSuspense;
function ar(e, t) {
	t && t.pendingBranch ? h(e) ? t.effects.push(...e) : t.effects.push(e) : hn(e);
}
var or = /* @__PURE__ */ Symbol.for("v-fgt"), sr = /* @__PURE__ */ Symbol.for("v-txt"), cr = /* @__PURE__ */ Symbol.for("v-cmt");
function lr(e) {
	return e ? e.__v_isVNode === !0 : !1;
}
var ur = (...e) => gr(...e), dr = ({ key: e }) => e ?? null, fr = ({ ref: e, ref_key: t, ref_for: n }) => (typeof e == "number" && (e = "" + e), e == null ? null : y(e) || /* @__PURE__ */ O(e) || v(e) ? {
	i: On,
	r: e,
	k: t,
	f: !!n
} : e);
function pr(e, t = null, n = null, r = 0, i = null, a = e === or ? 0 : 1, o = !1, s = !1) {
	let c = {
		__v_isVNode: !0,
		__v_skip: !0,
		type: e,
		props: t,
		key: t && dr(t),
		ref: t && fr(t),
		scopeId: kn,
		slotScopeIds: null,
		children: n,
		component: null,
		suspense: null,
		ssContent: null,
		ssFallback: null,
		dirs: null,
		transition: null,
		el: null,
		anchor: null,
		target: null,
		targetStart: null,
		targetAnchor: null,
		staticCount: 0,
		shapeFlag: a,
		patchFlag: r,
		dynamicProps: i,
		dynamicChildren: null,
		appContext: null,
		ctx: On
	};
	if (s ? (xr(c, n), a & 128 && e.normalize(c)) : n && (c.shapeFlag |= y(n) ? 8 : 16), process.env.NODE_ENV !== "production" && c.key !== c.key && k("VNode created with invalid key (NaN). VNode type:", c.type), process.env.NODE_ENV !== "production" && t && c.shapeFlag & 1) {
		let e = t.innerHTML == null ? t.textContent == null ? null : "textContent" : "innerHTML";
		e && mr(c.children) && k(`The \`${e}\` prop on <${c.type}> will override its children. Remove either the \`${e}\` prop or the children.`);
	}
	return c;
}
function mr(e) {
	return y(e) ? e !== "" : h(e) ? e.length > 0 : !1;
}
var hr = process.env.NODE_ENV === "production" ? gr : ur;
function gr(e, t = null, n = null, r = 0, i = null, a = !1) {
	if ((!e || e === Vn) && (process.env.NODE_ENV !== "production" && !e && k(`Invalid vnode type when creating vnode: ${e}.`), e = cr), lr(e)) {
		let r = vr(e, t, !0);
		return n && xr(r, n), r.patchFlag = -2, r;
	}
	if (Pr(e) && (e = e.__vccOpts), t) {
		t = _r(t);
		let { class: e, style: n } = t;
		e && !y(e) && (t.class = me(e)), x(n) && (/* @__PURE__ */ At(n) && !h(n) && (n = f({}, n)), t.style = le(n));
	}
	let o = y(e) ? 1 : ir(e) ? 128 : In(e) ? 64 : x(e) ? 4 : v(e) ? 2 : 0;
	return process.env.NODE_ENV !== "production" && o & 4 && /* @__PURE__ */ At(e) && (e = /* @__PURE__ */ D(e), k("Vue received a Component that was made a reactive object. This can lead to unnecessary performance overhead and should be avoided by marking the component with `markRaw` or using `shallowRef` instead of `ref`.", "\nComponent that was made reactive: ", e)), pr(e, t, n, r, i, o, a, !0);
}
function _r(e) {
	return e ? /* @__PURE__ */ At(e) || nr(e) ? f({}, e) : e : null;
}
function vr(e, t, n = !1, r = !1) {
	let { props: i, ref: a, patchFlag: o, children: s, transition: c } = e, l = t ? Sr(i || {}, t) : i, u = {
		__v_isVNode: !0,
		__v_skip: !0,
		type: e.type,
		props: l,
		key: l && dr(l),
		ref: t && t.ref ? n && a ? h(a) ? a.concat(fr(t)) : [a, fr(t)] : fr(t) : a,
		scopeId: e.scopeId,
		slotScopeIds: e.slotScopeIds,
		children: process.env.NODE_ENV !== "production" && o === -1 && h(s) ? s.map(yr) : s,
		target: e.target,
		targetStart: e.targetStart,
		targetAnchor: e.targetAnchor,
		staticCount: e.staticCount,
		shapeFlag: e.shapeFlag,
		patchFlag: t && e.type !== or ? o === -1 ? 16 : o | 16 : o,
		dynamicProps: e.dynamicProps,
		dynamicChildren: e.dynamicChildren,
		appContext: e.appContext,
		dirs: e.dirs,
		transition: c,
		component: e.component,
		suspense: e.suspense,
		ssContent: e.ssContent && vr(e.ssContent),
		ssFallback: e.ssFallback && vr(e.ssFallback),
		placeholder: e.placeholder,
		el: e.el,
		anchor: e.anchor,
		ctx: e.ctx,
		ce: e.ce
	};
	return c && r && zn(u, c.clone(u)), u;
}
function yr(e) {
	let t = vr(e);
	return h(e.children) && (t.children = e.children.map(yr)), t;
}
function br(e = " ", t = 0) {
	return hr(sr, null, e, t);
}
function xr(e, t) {
	let n = 0, { shapeFlag: r } = e;
	if (t == null) t = null;
	else if (h(t)) n = 16;
	else if (typeof t == "object") {
		if (r & 65) {
			let n = t.default;
			n && (n._c && (n._d = !1), xr(e, n()), n._c && (n._d = !0));
			return;
		}
		n = 32, !t._ && !nr(t) && (t._ctx = On);
	} else if (v(t)) {
		if (r & 65) {
			xr(e, { default: t });
			return;
		}
		t = {
			default: t,
			_ctx: On
		}, n = 32;
	} else t = String(t), r & 64 ? (n = 16, t = [br(t)]) : n = 8;
	e.children = t, e.shapeFlag |= n;
}
function Sr(...e) {
	let t = {};
	for (let n = 0; n < e.length; n++) {
		let r = e[n];
		for (let e in r) if (e === "class") t.class !== r.class && (t.class = me([t.class, r.class]));
		else if (e === "style") t.style = le([t.style, r.style]);
		else if (u(e)) {
			let n = t[e], i = r[e];
			i && n !== i && !(h(n) && n.includes(i)) ? t[e] = n ? [].concat(n, i) : i : i == null && n == null && !d(e) && (t[e] = i);
		} else e !== "" && (t[e] = r[e]);
	}
	return t;
}
var Cr = null, wr = () => Cr || On, Tr;
{
	let e = ce(), t = (t, n) => {
		let r;
		return (r = e[t]) || (r = e[t] = []), r.push(n), (e) => {
			r.length > 1 ? r.forEach((t) => t(e)) : r[0](e);
		};
	};
	Tr = t("__VUE_INSTANCE_SETTERS__", (e) => Cr = e), t("__VUE_SSR_SETTERS__", (e) => Or = e);
}
var Er = (e) => {
	let t = Cr;
	return Tr(e), e.scope.on(), () => {
		e.scope.off(), Tr(t);
	};
};
function Dr(e) {
	return e.vnode.shapeFlag & 4;
}
var Or = !1;
process.env.NODE_ENV;
function kr(e) {
	return e.exposed ? e.exposeProxy ||= new Proxy(It(jt(e.exposed)), {
		get(t, n) {
			if (n in t) return t[n];
			if (n in Un) return Un[n](e);
		},
		has(e, t) {
			return t in e || t in Un;
		}
	}) : e.proxy;
}
var Ar = /(?:^|[-_])\w/g, jr = (e) => e.replace(Ar, (e) => e.toUpperCase()).replace(/[-_]/g, "");
function Mr(e, t = !0) {
	return v(e) ? e.displayName || e.name : e.name || t && e.__name;
}
function Nr(e, t, n = !1) {
	let r = Mr(t);
	if (!r && t.__file) {
		let e = t.__file.match(/([^/\\]+)\.\w+$/);
		e && (r = e[1]);
	}
	if (!r && e) {
		let n = (e) => {
			for (let n in e) if (e[n] === t) return n;
		};
		r = n(e.components) || e.parent && n(e.parent.type.components) || n(e.appContext.components);
	}
	return r ? jr(r) : n ? "App" : "Anonymous";
}
function Pr(e) {
	return v(e) && "__vccOpts" in e;
}
function Fr() {
	if (process.env.NODE_ENV === "production" || typeof window > "u") return;
	let e = { style: "color:#3ba776" }, t = { style: "color:#1677ff" }, n = { style: "color:#f5222d" }, r = { style: "color:#eb2f96" }, i = {
		__vue_custom_formatter: !0,
		header(t) {
			if (!x(t)) return null;
			if (t.__isVue) return [
				"div",
				e,
				"VueInstance"
			];
			if (/* @__PURE__ */ O(t)) {
				Me();
				let n = t.value;
				return Ne(), [
					"div",
					{},
					[
						"span",
						e,
						d(t)
					],
					"<",
					s(n),
					">"
				];
			}
			return /* @__PURE__ */ Ot(t) ? [
				"div",
				{},
				[
					"span",
					e,
					/* @__PURE__ */ E(t) ? "ShallowReactive" : "Reactive"
				],
				"<",
				s(t),
				`>${/* @__PURE__ */ kt(t) ? " (readonly)" : ""}`
			] : /* @__PURE__ */ kt(t) ? [
				"div",
				{},
				[
					"span",
					e,
					/* @__PURE__ */ E(t) ? "ShallowReadonly" : "Readonly"
				],
				"<",
				s(t),
				">"
			] : null;
		},
		hasBody(e) {
			return e && e.__isVue;
		},
		body(e) {
			if (e && e.__isVue) return [
				"div",
				{},
				...a(e.$)
			];
		}
	};
	function a(e) {
		let t = [];
		e.type.props && e.props && t.push(o("props", /* @__PURE__ */ D(e.props))), e.setupState !== c && t.push(o("setup", e.setupState)), e.data !== c && t.push(o("data", /* @__PURE__ */ D(e.data)));
		let n = l(e, "computed");
		n && t.push(o("computed", n));
		let i = l(e, "inject");
		return i && t.push(o("injected", i)), t.push([
			"div",
			{},
			[
				"span",
				{ style: r.style + ";opacity:0.66" },
				"$ (internal): "
			],
			["object", { object: e }]
		]), t;
	}
	function o(e, t) {
		return t = f({}, t), Object.keys(t).length ? [
			"div",
			{ style: "line-height:1.25em;margin-bottom:0.6em" },
			[
				"div",
				{ style: "color:#476582" },
				e
			],
			[
				"div",
				{ style: "padding-left:1.25em" },
				...Object.keys(t).map((e) => [
					"div",
					{},
					[
						"span",
						r,
						e + ": "
					],
					s(t[e], !1)
				])
			]
		] : ["span", {}];
	}
	function s(e, i = !0) {
		return typeof e == "number" ? [
			"span",
			t,
			e
		] : typeof e == "string" ? [
			"span",
			n,
			JSON.stringify(e)
		] : typeof e == "boolean" ? [
			"span",
			r,
			e
		] : x(e) ? ["object", { object: i ? /* @__PURE__ */ D(e) : e }] : [
			"span",
			n,
			String(e)
		];
	}
	function l(e, t) {
		let n = e.type;
		if (v(n)) return;
		let r = {};
		for (let i in e.ctx) u(n, i, t) && (r[i] = e.ctx[i]);
		return r;
	}
	function u(e, t, n) {
		let r = e[n];
		if (h(r) && r.includes(t) || x(r) && t in r || e.extends && u(e.extends, t, n) || e.mixins && e.mixins.some((e) => u(e, t, n))) return !0;
	}
	function d(e) {
		return /* @__PURE__ */ E(e) ? "ShallowRef" : e.effect ? "ComputedRef" : "Ref";
	}
	window.devtoolsFormatters ? window.devtoolsFormatters.push(i) : window.devtoolsFormatters = [i];
}
process.env.NODE_ENV, process.env.NODE_ENV, process.env.NODE_ENV;
//#endregion
//#region ../../node_modules/.pnpm/vue@3.5.41_typescript@6.0.3/node_modules/vue/dist/vue.runtime.esm-bundler.js
function Ir() {
	Fr();
}
process.env.NODE_ENV !== "production" && Ir();
//#endregion
//#region ../../libs/utils/dist/index.js
var Lr = Object.create, Rr = Object.defineProperty, zr = Object.getOwnPropertyDescriptor, Br = Object.getOwnPropertyNames, Vr = Object.getPrototypeOf, Hr = Object.prototype.hasOwnProperty, M = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), Ur = (e, t, n, r) => {
	if (t && typeof t == "object" || typeof t == "function") for (var i = Br(t), a = 0, o = i.length, s; a < o; a++) s = i[a], !Hr.call(e, s) && s !== n && Rr(e, s, {
		get: ((e) => t[e]).bind(null, s),
		enumerable: !(r = zr(t, s)) || r.enumerable
	});
	return e;
}, Wr = (e, t, n) => (n = e == null ? {} : Lr(Vr(e)), Ur(t || !e || !e.__esModule || !Hr.call(e, "default") ? Rr(n, "default", {
	value: e,
	enumerable: !0
}) : n, e)), N = {
	PostNl: 1,
	Bpost: 2,
	CheapCargo: 3,
	Dpd: 4,
	Instabox: 5,
	Dhl: 6,
	Bol: 7,
	Ups: 8,
	DhlForYou: 9,
	DhlParcelConnect: 10,
	DhlEuroPlus: 11,
	UpsStandard: 12,
	UpsExpressSaver: 13,
	Gls: 14,
	Brt: 15,
	Trunkrs: 16,
	InPost: 17,
	PosteItaliane: 18,
	Spring: 19,
	ViaTim: 20,
	DhlFreight: 21
}, P = {
	PostNl: "postnl",
	POSTNL: "POSTNL",
	Bpost: "bpost",
	BPOST: "BPOST",
	CheapCargo: "cheapcargo",
	CHEAP_CARGO: "CHEAP_CARGO",
	Dpd: "dpd",
	DPD: "DPD",
	Instabox: "instabox",
	INSTABOX: "INSTABOX",
	Dhl: "dhl",
	BolCom: "bol.com",
	Bol: "bol",
	BOL: "BOL",
	Ups: "ups",
	UPS: "ups",
	DHL: "DHL",
	DhlForYou: "dhlforyou",
	DHL_FOR_YOU: "DHL_FOR_YOU",
	DhlParcelConnect: "dhlparcelconnect",
	DHL_PARCEL_CONNECT: "DHL_PARCEL_CONNECT",
	DhlEuroPlus: "dhleuroplus",
	DHL_EUROPLUS: "DHL_EUROPLUS",
	UpsStandard: "upsstandard",
	UPS_STANDARD: "UPS_STANDARD",
	UpsExpressSaver: "upsexpresssaver",
	UPS_EXPRESS_SAVER: "UPS_EXPRESS_SAVER",
	Gls: "gls",
	GLS: "GLS",
	Brt: "brt",
	BRT: "BRT",
	Trunkrs: "trunkrs",
	TRUNKRS: "TRUNKRS",
	InPost: "inpost",
	INPOST: "INPOST",
	PosteItaliane: "posteitaliane",
	POSTE_ITALIANE: "POSTE_ITALIANE",
	Spring: "spring",
	SPRING: "SPRING",
	ViaTim: "viatim",
	VIA_TIM: "VIA_TIM",
	DhlFreight: "dhlfreight",
	DHL_FREIGHT: "DHL_FREIGHT"
};
N.Dhl, N.Instabox, N.PostNl, P.PostNl, N.Bpost, P.Bpost, N.CheapCargo, P.CheapCargo, N.Dpd, P.Dpd, N.Instabox, P.Instabox, N.Dhl, P.Dhl, N.Bol, P.Bol, N.Ups, P.Ups, N.DhlForYou, P.DhlForYou, N.DhlParcelConnect, P.DhlParcelConnect, N.DhlEuroPlus, P.DhlEuroPlus, N.UpsStandard, P.UpsStandard, N.UpsExpressSaver, P.UpsExpressSaver, N.Gls, P.Gls, N.Brt, P.Brt, N.Trunkrs, P.Trunkrs, N.InPost, P.InPost, N.PosteItaliane, P.PosteItaliane, N.Spring, P.Spring, N.ViaTim, P.ViaTim, N.DhlFreight, P.DhlFreight, N.PostNl, P.POSTNL, N.Bpost, P.BPOST, N.CheapCargo, P.CHEAP_CARGO, N.Dpd, P.DPD, N.Instabox, P.INSTABOX, N.Dhl, P.DHL, N.Bol, P.BOL, N.Ups, P.UPS, N.DhlForYou, P.DHL_FOR_YOU, N.DhlParcelConnect, P.DHL_PARCEL_CONNECT, N.DhlEuroPlus, P.DHL_EUROPLUS, N.UpsStandard, P.UPS_STANDARD, N.UpsExpressSaver, P.UPS_EXPRESS_SAVER, N.Gls, P.GLS, N.Brt, P.BRT, N.Trunkrs, P.TRUNKRS, N.InPost, P.INPOST, N.PosteItaliane, P.POSTE_ITALIANE, N.Spring, P.SPRING, N.ViaTim, P.VIA_TIM, N.DhlFreight, P.DHL_FREIGHT, P.POSTNL, N.PostNl, P.BPOST, N.Bpost, P.CHEAP_CARGO, N.CheapCargo, P.DPD, N.Dpd, P.INSTABOX, N.Instabox, P.DHL, N.Dhl, P.BOL, N.Bol, P.UPS, N.Ups, P.DHL_FOR_YOU, N.DhlForYou, P.DHL_PARCEL_CONNECT, N.DhlParcelConnect, P.DHL_EUROPLUS, N.DhlEuroPlus, P.UPS_STANDARD, N.UpsStandard, P.UPS_EXPRESS_SAVER, N.UpsExpressSaver, P.GLS, N.Gls, P.BRT, N.Brt, P.TRUNKRS, N.Trunkrs, P.INPOST, N.InPost, P.POSTE_ITALIANE, N.PosteItaliane, P.SPRING, N.Spring, P.VIA_TIM, N.ViaTim, P.DHL_FREIGHT, N.DhlFreight, P.PostNl, N.PostNl, P.POSTNL, N.PostNl, P.Bpost, N.Bpost, P.BPOST, N.Bpost, P.CheapCargo, N.CheapCargo, P.CHEAP_CARGO, N.CheapCargo, P.Dpd, N.Dpd, P.DPD, N.Dpd, P.Instabox, N.Instabox, P.Dhl, N.Dhl, P.BolCom, N.Bol, P.Bol, N.Bol, P.BOL, N.Bol, P.Ups, N.Ups, P.DhlForYou, N.DhlForYou, P.DHL_FOR_YOU, N.DhlForYou, P.DhlParcelConnect, N.DhlParcelConnect, P.DHL_PARCEL_CONNECT, N.DhlParcelConnect, P.DhlEuroPlus, N.DhlEuroPlus, P.DHL_EUROPLUS, N.DhlEuroPlus, P.UpsStandard, N.UpsStandard, P.UPS_STANDARD, N.UpsStandard, P.UpsExpressSaver, N.UpsExpressSaver, P.UPS_EXPRESS_SAVER, N.UpsExpressSaver, P.Gls, N.Gls, P.GLS, N.Gls, P.Brt, N.Brt, P.BRT, N.Brt, P.Trunkrs, N.Trunkrs, P.TRUNKRS, N.Trunkrs, P.InPost, N.InPost, P.INPOST, N.InPost, P.PosteItaliane, N.PosteItaliane, P.POSTE_ITALIANE, N.PosteItaliane, P.Spring, N.Spring, P.SPRING, N.Spring, P.ViaTim, N.ViaTim, P.VIA_TIM, N.ViaTim, P.DhlFreight, N.DhlFreight, P.DHL_FREIGHT, N.DhlFreight, N.PostNl, N.Bpost, N.CheapCargo, N.Dpd, N.Instabox, N.Dhl, N.Bol, N.Ups, N.DhlForYou, N.DhlParcelConnect, N.DhlEuroPlus, N.UpsStandard, N.UpsExpressSaver, N.Gls, N.Brt, N.Trunkrs, N.InPost, N.PosteItaliane, N.Spring, N.ViaTim, N.DhlFreight;
var F = {
	Afghanistan: "AF",
	AlandIslands: "AX",
	Albania: "AL",
	Algeria: "DZ",
	AmericanSamoa: "AS",
	AmericanVirginIslands: "VI",
	Andorra: "AD",
	Angola: "AO",
	Anguilla: "AI",
	Antarctica: "AQ",
	AntiguaAndBarbuda: "AG",
	Argentina: "AR",
	Armenia: "AM",
	Aruba: "AW",
	Australia: "AU",
	Austria: "AT",
	Azerbaijan: "AZ",
	Bahamas: "BS",
	Bahrain: "BH",
	Bangladesh: "BD",
	Barbados: "BB",
	Belarus: "BY",
	Belgium: "BE",
	Belize: "BZ",
	Benin: "BJ",
	Bermuda: "BM",
	Bhutan: "BT",
	Bolivia: "BO",
	BonaireSintEustatiusAndSaba: "BQ",
	BosniaAndHerzegovina: "BA",
	Botswana: "BW",
	BouvetIsland: "BV",
	Brazil: "BR",
	BritishIndianOceanTerritory: "IO",
	BritishVirginIslands: "VG",
	BruneiDarussalam: "BN",
	Bulgaria: "BG",
	BurkinaFaso: "BF",
	Burundi: "BI",
	CaboVerde: "CV",
	Cambodia: "KH",
	Cameroon: "CM",
	Canada: "CA",
	CanaryIslands: "IC",
	CaymanIslands: "KY",
	CentralAfricanRepublic: "CF",
	Chad: "TD",
	Chile: "CL",
	China: "CN",
	ChristmasIsland: "CX",
	CocosIslands: "CC",
	Colombia: "CO",
	Comoros: "KM",
	CongoBrazzaville: "CG",
	CongoKinshasa: "CD",
	CookIslands: "CK",
	CostaRica: "CR",
	CoteDIvoire: "CI",
	Croatia: "HR",
	Cuba: "CU",
	Curacao: "CW",
	Cyprus: "CY",
	CzechRepublic: "CZ",
	Denmark: "DK",
	Djibouti: "DJ",
	Dominica: "DM",
	DominicanRepublic: "DO",
	DutchAntilles: "AN",
	Ecuador: "EC",
	Egypt: "EG",
	ElSalvador: "SV",
	EquatorialGuinea: "GQ",
	Eritrea: "ER",
	Estonia: "EE",
	Eswatini: "SZ",
	Ethiopia: "ET",
	FalklandIslands: "FK",
	FaroeIslands: "FO",
	Fiji: "FJ",
	Finland: "FI",
	France: "FR",
	FrenchGuiana: "GF",
	FrenchPolynesia: "PF",
	FrenchSouthernTerritories: "TF",
	Gabon: "GA",
	Gambia: "GM",
	Georgia: "GE",
	Germany: "DE",
	Ghana: "GH",
	Gibraltar: "GI",
	Greece: "GR",
	Greenland: "GL",
	Grenada: "GD",
	Guadeloupe: "GP",
	Guam: "GU",
	Guatemala: "GT",
	Guernsey: "GG",
	Guinea: "GN",
	GuineaBissau: "GW",
	Guyana: "GY",
	Haiti: "HT",
	HeardIslandAndMcdonaldIslands: "HM",
	HolySee: "VA",
	Honduras: "HN",
	HongKong: "HK",
	Hungary: "HU",
	Iceland: "IS",
	India: "IN",
	Indonesia: "ID",
	Iran: "IR",
	Iraq: "IQ",
	Ireland: "IE",
	IsleOfMan: "IM",
	Israel: "IL",
	Italy: "IT",
	Jamaica: "JM",
	Japan: "JP",
	Jersey: "JE",
	Jordan: "JO",
	Kazakhstan: "KZ",
	Kenya: "KE",
	Kiribati: "KI",
	KoreaPeoplesDemocraticRepublic: "KP",
	KoreaRepublic: "KR",
	Kosovo: "XK",
	Kuwait: "KW",
	Kyrgyzstan: "KG",
	Laos: "LA",
	Latvia: "LV",
	Lebanon: "LB",
	Lesotho: "LS",
	Liberia: "LR",
	Libya: "LY",
	Liechtenstein: "LI",
	Lithuania: "LT",
	Luxembourg: "LU",
	Macao: "MO",
	Madagascar: "MG",
	Malawi: "MW",
	Malaysia: "MY",
	Maldives: "MV",
	Mali: "ML",
	Malta: "MT",
	MarshallIslands: "MH",
	Martinique: "MQ",
	Mauritania: "MR",
	Mauritius: "MU",
	Mayotte: "YT",
	Mexico: "MX",
	Micronesia: "FM",
	Moldova: "MD",
	Monaco: "MC",
	Mongolia: "MN",
	Montenegro: "ME",
	Montserrat: "MS",
	Morocco: "MA",
	Mozambique: "MZ",
	Myanmar: "MM",
	Namibia: "NA",
	Nauru: "NR",
	Nepal: "NP",
	Netherlands: "NL",
	NewCaledonia: "NC",
	NewZealand: "NZ",
	Nicaragua: "NI",
	Niger: "NE",
	Nigeria: "NG",
	Niue: "NU",
	NorfolkIsland: "NF",
	NorthMacedonia: "MK",
	NorthernMarianaIslands: "MP",
	Norway: "NO",
	Oman: "OM",
	Pakistan: "PK",
	Palau: "PW",
	Palestine: "PS",
	Panama: "PA",
	PapuaNewGuinea: "PG",
	Paraguay: "PY",
	Peru: "PE",
	Philippines: "PH",
	Pitcairn: "PN",
	Poland: "PL",
	Portugal: "PT",
	PuertoRico: "PR",
	Qatar: "QA",
	Reunion: "RE",
	Romania: "RO",
	RussianFederation: "RU",
	Rwanda: "RW",
	SaintBarthelemy: "BL",
	SaintHelena: "SH",
	SaintKittsAndNevis: "KN",
	SaintLucia: "LC",
	SaintMartin: "MF",
	SaintPierreAndMiquelon: "PM",
	SaintVincentAndTheGrenadines: "VC",
	Samoa: "WS",
	SanMarino: "SM",
	SaoTomeAndPrincipe: "ST",
	SaudiArabia: "SA",
	Senegal: "SN",
	Serbia: "RS",
	Seychelles: "SC",
	SierraLeone: "SL",
	Singapore: "SG",
	SintMaarten: "SX",
	Slovakia: "SK",
	Slovenia: "SI",
	SolomonIslands: "SB",
	Somalia: "SO",
	SouthAfrica: "ZA",
	SouthGeorgiaAndTheSouthSandwichIslands: "GS",
	SouthSudan: "SS",
	Spain: "ES",
	SriLanka: "LK",
	Sudan: "SD",
	Suriname: "SR",
	SvalbardAndJanMayen: "SJ",
	Sweden: "SE",
	Switzerland: "CH",
	SyrianArabRepublic: "SY",
	Taiwan: "TW",
	Tajikistan: "TJ",
	Tanzania: "TZ",
	Thailand: "TH",
	TimorLeste: "TL",
	Togo: "TG",
	Tokelau: "TK",
	Tonga: "TO",
	TrinidadAndTobago: "TT",
	Tunisia: "TN",
	Turkey: "TR",
	Turkmenistan: "TM",
	TurksAndCaicosIslands: "TC",
	Tuvalu: "TV",
	Uganda: "UG",
	Ukraine: "UA",
	UnitedArabEmirates: "AE",
	UnitedKingdom: "GB",
	UnitedStatesMinorOutlyingIslands: "UM",
	UnitedStatesOfAmerica: "US",
	Uruguay: "UY",
	Uzbekistan: "UZ",
	Vanuatu: "VU",
	Venezuela: "VE",
	Vietnam: "VN",
	WallisAndFutuna: "WF",
	WesternSahara: "EH",
	Yemen: "YE",
	Zambia: "ZM",
	Zimbabwe: "ZW"
};
F.Austria, F.Belgium, F.Bulgaria, F.Croatia, F.Cyprus, F.CzechRepublic, F.Denmark, F.Estonia, F.Finland, F.France, F.Germany, F.Greece, F.Hungary, F.Ireland, F.Italy, F.Latvia, F.Lithuania, F.Luxembourg, F.Malta, F.Netherlands, F.Poland, F.Portugal, F.Romania, F.Slovakia, F.Slovenia, F.Spain, F.Sweden, Object.values(F), F.Angola, F.AntiguaAndBarbuda, F.Aruba, F.Bahamas, F.Belize, F.Benin, F.Bermuda, F.BonaireSintEustatiusAndSaba, F.Botswana, F.BurkinaFaso, F.Burundi, F.Cameroon, F.CanaryIslands, F.CentralAfricanRepublic, F.Comoros, F.CongoBrazzaville, F.CongoKinshasa, F.CoteDIvoire, F.Curacao, F.Djibouti, F.Dominica, F.DutchAntilles, F.EquatorialGuinea, F.Eritrea, F.Fiji, F.Gabon, F.Gambia, F.Ghana, F.Grenada, F.Guyana, F.HongKong, F.Kiribati, F.KoreaPeoplesDemocraticRepublic, F.Macao, F.Malawi, F.Mali, F.Mauritania, F.Nauru, F.Qatar, F.Rwanda, F.SaintKittsAndNevis, F.SaoTomeAndPrincipe, F.Seychelles, F.SierraLeone, F.SintMaarten, F.Suriname, F.SyrianArabRepublic, F.TimorLeste, F.Togo, F.Tonga, F.Tuvalu, F.Uganda, F.UnitedArabEmirates, F.Vanuatu, F.Yemen, F.Zimbabwe, F.Austria, F.Belgium, F.Bulgaria, F.Croatia, F.CzechRepublic, F.Estonia, F.Finland, F.France, F.Germany, F.Greece, F.Hungary, F.Ireland, F.Italy, F.Latvia, F.Lithuania, F.Luxembourg, F.Malta, F.Netherlands, F.Portugal, F.Romania, F.Slovakia, F.Slovenia, F.Spain, F.UnitedKingdom, F.Denmark, F.Germany, F.Sweden;
var I = {
	EarlyMorning: 8,
	Morning: 1,
	Standard: 2,
	Evening: 3,
	Pickup: 4,
	PickupExpress: 5,
	SameDayDelivery: 6,
	Express: 7
}, L = {
	EarlyMorning: "early_morning",
	Morning: "morning",
	Standard: "standard",
	Evening: "evening",
	Pickup: "pickup",
	PickupExpress: "pickup_express",
	SameDayDelivery: "same_day",
	Express: "express"
}, R = {
	EarlyMorning: "EARLY_MORNING_DELIVERY",
	Morning: "MORNING_DELIVERY",
	Standard: "STANDARD_DELIVERY",
	Evening: "EVENING_DELIVERY",
	Pickup: "PICKUP_DELIVERY",
	PickupExpress: "PICKUP_EXPRESS_DELIVERY",
	SameDayDelivery: "SAME_DAY_DELIVERY",
	Express: "EXPRESS_DELIVERY"
};
I.EarlyMorning, L.EarlyMorning, I.Morning, L.Morning, I.Standard, L.Standard, I.Evening, L.Evening, I.Pickup, L.Pickup, I.PickupExpress, L.PickupExpress, I.SameDayDelivery, L.SameDayDelivery, I.Express, L.Express, L.EarlyMorning, I.EarlyMorning, L.Morning, I.Morning, L.Standard, I.Standard, L.Evening, I.Evening, L.Pickup, I.Pickup, L.PickupExpress, I.PickupExpress, L.SameDayDelivery, I.SameDayDelivery, L.Express, I.Express, I.EarlyMorning, R.EarlyMorning, I.Morning, R.Morning, I.Standard, R.Standard, I.Evening, R.Evening, I.Pickup, R.Pickup, I.PickupExpress, R.PickupExpress, I.SameDayDelivery, R.SameDayDelivery, I.Express, R.Express, R.EarlyMorning, L.EarlyMorning, R.Morning, L.Morning, R.Standard, L.Standard, R.Evening, L.Evening, R.Pickup, L.Pickup, R.PickupExpress, L.PickupExpress, R.SameDayDelivery, L.SameDayDelivery, R.Express, L.Express, I.EarlyMorning, I.Morning, I.Standard, I.Evening, I.Pickup, I.PickupExpress, I.SameDayDelivery, I.Express, { Vasco: 1 }.Vasco, { Vasco: "vasco" }.Vasco;
var z = {
	Sunday: 0,
	Monday: 1,
	Tuesday: 2,
	Wednesday: 3,
	Thursday: 4,
	Friday: 5,
	Saturday: 6
}, B = {
	Sunday: "sunday",
	Monday: "monday",
	Tuesday: "tuesday",
	Wednesday: "wednesday",
	Thursday: "thursday",
	Friday: "friday",
	Saturday: "saturday"
};
B.Sunday, z.Sunday, B.Monday, z.Monday, B.Tuesday, z.Tuesday, B.Wednesday, z.Wednesday, B.Thursday, z.Thursday, B.Friday, z.Friday, B.Saturday, z.Saturday, z.Sunday, B.Sunday, z.Monday, B.Monday, z.Tuesday, B.Tuesday, z.Wednesday, B.Wednesday, z.Thursday, B.Thursday, z.Friday, B.Friday, z.Saturday, B.Saturday;
var Gr = {
	Bytes: "B",
	Kilobytes: "KB",
	Megabytes: "MB",
	Gigabytes: "GB",
	Terabytes: "TB"
};
Gr.Bytes, Gr.Kilobytes, Gr.Megabytes, Gr.Gigabytes, Gr.Terabytes;
var V = {
	Bol: 1,
	Exact: 2,
	Amazon: 6,
	Wix: 8,
	ExactDe: 10,
	Etsy: 11
}, H = {
	Bol: "bol_dot_com",
	Wix: "wix",
	Exact: "exact",
	ExactDe: "exact_de",
	Amazon: "amazon",
	Etsy: "etsy"
};
V.Bol, H.Bol, V.Exact, H.Exact, V.Amazon, H.Amazon, V.Wix, H.Wix, V.ExactDe, H.ExactDe, V.Etsy, H.Etsy, H.Bol, V.Bol, H.Exact, V.Exact, H.Amazon, V.Amazon, H.Wix, V.Wix, H.ExactDe, V.ExactDe, H.Etsy, V.Etsy;
var U = {
	Unpaid: 1,
	Due: 101,
	DuePrepayment: 102,
	Reminder1: 106,
	Reminder2: 111,
	Dun: 116,
	Collection: 121,
	Instalments: 126,
	PaymentArrangement: 127,
	Dispute: 128,
	LegalProcedure: 129,
	Insolvency: 130,
	WriteOff: 131,
	Pending: 301,
	Cancelled: 401,
	Paid: 501,
	PaidOnline: 506,
	PaidAutomatic: 511,
	PaidCredit: 597,
	PaidZeroItems: 598,
	InvoiceWith0InvoiceItemsPaidZeroBalance: 599
}, W = {
	Unpaid: "Unpaid",
	Due: "Due",
	DuePrepayment: "DuePrepayment",
	Reminder1: "Reminder1",
	Reminder2: "Reminder2",
	Dun: "Dun",
	Collection: "Collection",
	Instalments: "Instalments",
	PaymentArrangement: "PaymentArrangement",
	Dispute: "Dispute",
	LegalProcedure: "LegalProcedure",
	Insolvency: "Insolvency",
	WriteOff: "WriteOff",
	Pending: "Pending",
	Cancelled: "Cancelled",
	Paid: "Paid",
	PaidOnline: "PaidOnline",
	PaidAutomatic: "PaidAutomatic",
	PaidCredit: "PaidCredit",
	PaidZeroItems: "PaidZeroItems",
	PaidZeroBalance: "PaidZeroBalance"
};
U.Unpaid, W.Unpaid, U.Due, W.Due, U.DuePrepayment, W.DuePrepayment, U.Reminder1, W.Reminder1, U.Reminder2, W.Reminder2, U.Dun, W.Dun, U.Collection, W.Collection, U.Instalments, W.Instalments, U.PaymentArrangement, W.PaymentArrangement, U.Dispute, W.Dispute, U.LegalProcedure, W.LegalProcedure, U.Insolvency, W.Insolvency, U.WriteOff, W.WriteOff, U.Pending, W.Pending, U.Cancelled, W.Cancelled, U.Paid, W.Paid, U.PaidOnline, W.PaidOnline, U.PaidAutomatic, W.PaidAutomatic, U.PaidCredit, W.PaidCredit, U.PaidZeroItems, W.PaidZeroItems, U.InvoiceWith0InvoiceItemsPaidZeroBalance, W.PaidZeroBalance, U.Due, U.Reminder1, U.Reminder2, U.Dun, U.Collection, U.Instalments, U.PaymentArrangement, U.Dispute, U.Paid, U.PaidOnline, U.PaidAutomatic, U.PaidCredit, U.PaidZeroItems;
var Kr = {
	Gram: "gram",
	Kilogram: "kilogram"
}, qr = {
	Gram: "g",
	Kilogram: "kg"
}, Jr = {
	[qr.Gram]: 1,
	[qr.Kilogram]: 1e3
}, Yr = {
	Millimeter: "millimeter",
	Centimeter: "centimeter",
	Meter: "meter"
}, Xr = {
	Millimeter: "mm",
	Centimeter: "cm",
	Meter: "m"
}, Zr = {
	[Xr.Millimeter]: .1,
	[Xr.Centimeter]: 1,
	[Xr.Meter]: 100
}, G = {
	Eu: "EU",
	HomeCountry: "Home Country",
	Row: "ROW",
	Cd: "CD",
	World: "WERELD"
}, Qr = {
	PendingConcept: 1,
	PendingRegistered: 2,
	EnRouteHandedToCarrier: 3,
	EnRouteSorting: 4,
	EnRouteDistribution: 5,
	EnRouteCustoms: 6,
	DeliveredAtRecipient: 7,
	DeliveredReadyForPickup: 8,
	DeliveredPackagePickedUp: 9,
	DeliveredReturnShipmentReadyForPickup: 10,
	DeliveredReturnShipmentPackagePickedUp: 11,
	PrintedLetter: 12,
	InactiveCredited: 13,
	PrintedDigitalStamp: 14,
	Expired: 16,
	Cancelled: 17,
	InactiveConcept: 30,
	InactiveRegistered: 31,
	InactiveEnRouteHandedToCarrier: 32,
	InactiveEnRouteSorting: 33,
	InactiveEnRouteDistribution: 34,
	InactiveEnRouteCustoms: 35,
	InactiveDeliveredAtRecipient: 36,
	InactiveDeliveredReadyForPickup: 37,
	InactiveDeliveredPackagePickedUp: 38
};
Qr.PendingConcept, Qr.PendingRegistered, Qr.EnRouteHandedToCarrier, Qr.EnRouteSorting, Qr.EnRouteDistribution, Qr.EnRouteCustoms, Qr.DeliveredReadyForPickup, Qr.DeliveredAtRecipient, Qr.DeliveredPackagePickedUp;
var K = {
	Light: "light",
	Start: "start",
	Plus: "plus",
	Premium: "premium",
	Max: "max"
}, $r = {
	Light: 0,
	Start: 1,
	Plus: 2,
	Premium: 3,
	Max: 4
};
$r.Light, K.Light, $r.Start, K.Start, $r.Plus, K.Plus, $r.Premium, K.Premium, $r.Max, K.Max, K.Light, $r.Light, K.Start, $r.Start, K.Plus, $r.Plus, K.Premium, $r.Premium, K.Max, $r.Max;
var ei = {
	Start: 4800,
	Plus: 4801,
	Premium: 4802,
	Max: 4803
}, ti = {
	Start: K.Start,
	Plus: K.Plus,
	Premium: K.Premium,
	Max: K.Max
};
ei.Start, ti.Start, ei.Plus, ti.Plus, ei.Premium, ti.Premium, ei.Max, ti.Max, ti.Start, ei.Start, ti.Plus, ei.Plus, ti.Premium, ei.Premium, ti.Max, ei.Max;
var ni = {
	Start: 4700,
	Plus: 4701,
	Premium: 4702,
	Max: 4703
}, ri = {
	Start: K.Start,
	Plus: K.Plus,
	Premium: K.Premium,
	Max: K.Max
};
ni.Start, ri.Start, ni.Plus, ri.Plus, ni.Premium, ri.Premium, ni.Max, ri.Max, ri.Start, ni.Start, ri.Plus, ni.Plus, ri.Premium, ni.Premium, ri.Max, ni.Max;
var ii = {
	Light: 4610,
	Start: 4611,
	Plus: 4612,
	Premium: 4613,
	Max: 4614
}, ai = {
	Light: K.Light,
	Start: K.Start,
	Plus: K.Plus,
	Premium: K.Premium,
	Max: K.Max
};
ii.Light, ai.Light, ii.Start, ai.Start, ii.Plus, ai.Plus, ii.Premium, ai.Premium, ii.Max, ai.Max, ai.Light, ii.Light, ai.Start, ii.Start, ai.Plus, ii.Plus, ai.Premium, ii.Premium, ai.Max, ii.Max;
var oi = {
	Start: 4615,
	Plus: 4616,
	Premium: 4617,
	Max: 4618
}, si = {
	Start: K.Start,
	Plus: K.Plus,
	Premium: K.Premium,
	Max: K.Max
};
oi.Start, si.Start, oi.Plus, si.Plus, oi.Premium, si.Premium, oi.Max, si.Max, si.Start, oi.Start, si.Plus, oi.Plus, si.Premium, oi.Premium, si.Max, oi.Max;
var q = {
	MyParcel: 1,
	Flespakket: 2,
	SendMyParcel: 3,
	DeliverDutch: 4,
	PostNlPlugin: 5,
	MyParcelIt: 6
}, ci = {
	MyParcel: "myparcel",
	Flespakket: "flespakket",
	SendMyParcel: "belgie",
	DeliverDutch: "deliver-dutch",
	PostNlPlugin: "postnl-plugin",
	MyParcelIt: "italie"
}, J = {
	Default: "default",
	MyParcelNl: "myparcel-nederland",
	MyParcelBe: "myparcel-belgie",
	MyParcelIt: "myparcel-italie",
	DeliverDutch: "deliver-dutch",
	PostNlPlugin: "postnl-plugin"
};
q.MyParcel, ci.MyParcel, q.Flespakket, ci.Flespakket, q.SendMyParcel, ci.SendMyParcel, q.MyParcelIt, ci.MyParcelIt, q.DeliverDutch, ci.DeliverDutch, q.PostNlPlugin, ci.PostNlPlugin, q.MyParcel, J.MyParcelNl, q.Flespakket, J.MyParcelNl, q.SendMyParcel, J.MyParcelBe, q.MyParcelIt, J.MyParcelIt, q.DeliverDutch, J.DeliverDutch, q.PostNlPlugin, J.PostNlPlugin, J.MyParcelNl, q.MyParcel, J.MyParcelBe, q.SendMyParcel, J.MyParcelIt, q.MyParcelIt, J.MyParcelNl, G.HomeCountry, F.Netherlands, G.Eu, G.Row, F.Belgium, J.MyParcelBe, G.HomeCountry, F.Belgium, F.Netherlands, G.Eu, G.Row, J.MyParcelBe, G.HomeCountry, F.Belgium, G.Eu, G.Row, J.MyParcelNl, G.HomeCountry, F.Netherlands, G.Eu, G.Row, J.MyParcelNl, G.HomeCountry, F.Netherlands, F.Belgium, F.Luxembourg, N.Bpost, N.PostNl, N.DhlForYou, N.DhlParcelConnect, N.DhlEuroPlus, N.Ups, N.UpsStandard, N.UpsExpressSaver;
var Y = {
	Package: 1,
	Mailbox: 2,
	Letter: 3,
	DigitalStamp: 4,
	Pallet: 5,
	PackageSmall: 6,
	Envelope: 7
}, X = {
	Package: "package",
	Mailbox: "mailbox",
	Letter: "letter",
	DigitalStamp: "digital_stamp",
	Pallet: "pallet",
	PackageSmall: "package_small",
	Envelope: "envelope"
};
Y.Package, X.Package, Y.Mailbox, X.Mailbox, Y.Letter, X.Letter, Y.DigitalStamp, X.DigitalStamp, Y.Pallet, X.Pallet, Y.PackageSmall, X.PackageSmall, Y.Envelope, X.Envelope, X.Package, Y.Package, X.Mailbox, Y.Mailbox, X.Letter, Y.Letter, X.DigitalStamp, Y.DigitalStamp, X.Pallet, Y.Pallet, X.PackageSmall, Y.PackageSmall, X.Envelope, Y.Envelope;
var Z = {
	DIGITAL_STAMP: "DIGITAL_STAMP",
	ENVELOPE: "ENVELOPE",
	MAILBOX: "MAILBOX",
	PACKAGE: "PACKAGE",
	PALLET: "PALLET",
	SMALL_PACKAGE: "SMALL_PACKAGE",
	UNFRANKED: "UNFRANKED"
};
Y.Package, Z.PACKAGE, Y.Mailbox, Z.MAILBOX, Y.Letter, Z.UNFRANKED, Y.DigitalStamp, Z.DIGITAL_STAMP, Y.Pallet, Z.PALLET, Y.PackageSmall, Z.SMALL_PACKAGE, Y.Envelope, Z.ENVELOPE, Z.PACKAGE, Y.Package, Z.MAILBOX, Y.Mailbox, Z.UNFRANKED, Y.Letter, Z.DIGITAL_STAMP, Y.DigitalStamp, Z.PALLET, Y.Pallet, Z.SMALL_PACKAGE, Y.PackageSmall, Z.ENVELOPE, Y.Envelope, Y.Package, Y.Mailbox, Y.Letter, Y.DigitalStamp, Y.Pallet, Y.PackageSmall, Y.Envelope;
var Q = {
	PendingConcept: 1,
	PendingRegistered: 2,
	EnrouteHandedToCarrier: 3,
	EnrouteSorting: 4,
	EnrouteDistribution: 5,
	DeliveredAtCustoms: 6,
	DeliveredAtRecipient: 7,
	DeliveredReadyForPickup: 8,
	DeliveredPackagePickedUp: 9,
	DeliveredReturnShipmentReadyForPickup: 10,
	DeliveredReturnShipmentPackagePickedUp: 11,
	PrintedUnpaidLabel: 12,
	PrintedLetter: 12,
	Credited: 13,
	PrintedStamp: 14,
	PrintedDigitalStamp: 14,
	Expired: 16,
	Cancelled: 17,
	PrintedUntrackedShipment: 18,
	DeliveredAtAgreedLocation: 19,
	InactiveConcept: 30,
	InactiveRegistered: 31,
	InactiveEnrouteHandedToCarrier: 32,
	InactiveEnrouteSorting: 33,
	InactiveEnrouteDistribution: 34,
	InactiveEnrouteCustoms: 35,
	InactiveDeliveredAtRecipient: 36,
	InactiveDeliveredReadyForPickup: 37,
	InactiveDeliveredPackagePickedUp: 38,
	CreditRejected: 100,
	CreditApproved: 101
};
Q.PendingConcept, Q.PendingRegistered, Q.EnrouteHandedToCarrier, Q.EnrouteSorting, Q.EnrouteDistribution, Q.DeliveredAtCustoms, Q.DeliveredAtRecipient, Q.DeliveredPackagePickedUp, Q.DeliveredReturnShipmentPackagePickedUp, Q.DeliveredAtAgreedLocation, Q.PrintedLetter, Q.PrintedDigitalStamp, Q.InactiveConcept, Q.InactiveRegistered, Q.InactiveEnrouteHandedToCarrier, Q.InactiveEnrouteSorting, Q.InactiveEnrouteDistribution, Q.InactiveEnrouteCustoms, Q.InactiveDeliveredAtRecipient, Q.InactiveDeliveredReadyForPickup, Q.InactiveDeliveredPackagePickedUp;
var $ = {
	MILLIMETER: "mm",
	CENTIMETER: "cm",
	DECIMETER: "dm",
	METER: "m",
	KILOMETER: "km"
}, li = {
	GRAM: "g",
	KILOGRAM: "kg"
}, ui = /* @__PURE__ */ M(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs = r();
	})(e, (function() {
		var e = 1e3, t = 6e4, n = 36e5, r = "millisecond", i = "second", a = "minute", o = "hour", s = "day", c = "week", l = "month", u = "quarter", d = "year", f = "date", p = "Invalid Date", m = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, h = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, g = {
			name: "en",
			weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
			months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
			ordinal: function(e) {
				var t = [
					"th",
					"st",
					"nd",
					"rd"
				], n = e % 100;
				return "[" + e + (t[(n - 20) % 10] || t[n] || t[0]) + "]";
			}
		}, _ = function(e, t, n) {
			var r = String(e);
			return !r || r.length >= t ? e : "" + Array(t + 1 - r.length).join(n) + e;
		}, v = {
			s: _,
			z: function(e) {
				var t = -e.utcOffset(), n = Math.abs(t), r = Math.floor(n / 60), i = n % 60;
				return (t <= 0 ? "+" : "-") + _(r, 2, "0") + ":" + _(i, 2, "0");
			},
			m: function e(t, n) {
				if (t.date() < n.date()) return -e(n, t);
				var r = 12 * (n.year() - t.year()) + (n.month() - t.month()), i = t.clone().add(r, l), a = n - i < 0, o = t.clone().add(r + (a ? -1 : 1), l);
				return +(-(r + (n - i) / (a ? i - o : o - i)) || 0);
			},
			a: function(e) {
				return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
			},
			p: function(e) {
				return {
					M: l,
					y: d,
					w: c,
					d: s,
					D: f,
					h: o,
					m: a,
					s: i,
					ms: r,
					Q: u
				}[e] || String(e || "").toLowerCase().replace(/s$/, "");
			},
			u: function(e) {
				return e === void 0;
			}
		}, y = "en", b = {};
		b[y] = g;
		var x = "$isDayjsObject", ee = function(e) {
			return e instanceof ne || !(!e || !e[x]);
		}, te = function e(t, n, r) {
			var i;
			if (!t) return y;
			if (typeof t == "string") {
				var a = t.toLowerCase();
				b[a] && (i = a), n && (b[a] = n, i = a);
				var o = t.split("-");
				if (!i && o.length > 1) return e(o[0]);
			} else {
				var s = t.name;
				b[s] = t, i = s;
			}
			return !r && i && (y = i), i || !r && y;
		}, S = function(e, t) {
			if (ee(e)) return e.clone();
			var n = typeof t == "object" ? t : {};
			return n.date = e, n.args = arguments, new ne(n);
		}, C = v;
		C.l = te, C.i = ee, C.w = function(e, t) {
			return S(e, {
				locale: t.$L,
				utc: t.$u,
				x: t.$x,
				$offset: t.$offset
			});
		};
		var ne = function() {
			function g(e) {
				this.$L = te(e.locale, null, !0), this.parse(e), this.$x = this.$x || e.x || {}, this[x] = !0;
			}
			var _ = g.prototype;
			return _.parse = function(e) {
				this.$d = function(e) {
					var t = e.date, n = e.utc;
					if (t === null) return /* @__PURE__ */ new Date(NaN);
					if (C.u(t)) return /* @__PURE__ */ new Date();
					if (t instanceof Date) return new Date(t);
					if (typeof t == "string" && !/Z$/i.test(t)) {
						var r = t.match(m);
						if (r) {
							var i = r[2] - 1 || 0, a = (r[7] || "0").substring(0, 3);
							return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, a)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, a);
						}
					}
					return new Date(t);
				}(e), this.init();
			}, _.init = function() {
				var e = this.$d;
				this.$y = e.getFullYear(), this.$M = e.getMonth(), this.$D = e.getDate(), this.$W = e.getDay(), this.$H = e.getHours(), this.$m = e.getMinutes(), this.$s = e.getSeconds(), this.$ms = e.getMilliseconds();
			}, _.$utils = function() {
				return C;
			}, _.isValid = function() {
				return this.$d.toString() !== p;
			}, _.isSame = function(e, t) {
				var n = S(e);
				return this.startOf(t) <= n && n <= this.endOf(t);
			}, _.isAfter = function(e, t) {
				return S(e) < this.startOf(t);
			}, _.isBefore = function(e, t) {
				return this.endOf(t) < S(e);
			}, _.$g = function(e, t, n) {
				return C.u(e) ? this[t] : this.set(n, e);
			}, _.unix = function() {
				return Math.floor(this.valueOf() / 1e3);
			}, _.valueOf = function() {
				return this.$d.getTime();
			}, _.startOf = function(e, t) {
				var n = this, r = !!C.u(t) || t, u = C.p(e), p = function(e, t) {
					var i = C.w(n.$u ? Date.UTC(n.$y, t, e) : new Date(n.$y, t, e), n);
					return r ? i : i.endOf(s);
				}, m = function(e, t) {
					return C.w(n.toDate()[e].apply(n.toDate("s"), (r ? [
						0,
						0,
						0,
						0
					] : [
						23,
						59,
						59,
						999
					]).slice(t)), n);
				}, h = this.$W, g = this.$M, _ = this.$D, v = "set" + (this.$u ? "UTC" : "");
				switch (u) {
					case d: return r ? p(1, 0) : p(31, 11);
					case l: return r ? p(1, g) : p(0, g + 1);
					case c:
						var y = this.$locale().weekStart || 0, b = (h < y ? h + 7 : h) - y;
						return p(r ? _ - b : _ + (6 - b), g);
					case s:
					case f: return m(v + "Hours", 0);
					case o: return m(v + "Minutes", 1);
					case a: return m(v + "Seconds", 2);
					case i: return m(v + "Milliseconds", 3);
					default: return this.clone();
				}
			}, _.endOf = function(e) {
				return this.startOf(e, !1);
			}, _.$set = function(e, t) {
				var n, c = C.p(e), u = "set" + (this.$u ? "UTC" : ""), p = (n = {}, n[s] = u + "Date", n[f] = u + "Date", n[l] = u + "Month", n[d] = u + "FullYear", n[o] = u + "Hours", n[a] = u + "Minutes", n[i] = u + "Seconds", n[r] = u + "Milliseconds", n)[c], m = c === s ? this.$D + (t - this.$W) : t;
				if (c === l || c === d) {
					var h = this.clone().set(f, 1);
					h.$d[p](m), h.init(), this.$d = h.set(f, Math.min(this.$D, h.daysInMonth())).$d;
				} else p && this.$d[p](m);
				return this.init(), this;
			}, _.set = function(e, t) {
				return this.clone().$set(e, t);
			}, _.get = function(e) {
				return this[C.p(e)]();
			}, _.add = function(r, u) {
				var f, p = this;
				r = Number(r);
				var m = C.p(u), h = function(e) {
					var t = S(p);
					return C.w(t.date(t.date() + Math.round(e * r)), p);
				};
				if (m === l) return this.set(l, this.$M + r);
				if (m === d) return this.set(d, this.$y + r);
				if (m === s) return h(1);
				if (m === c) return h(7);
				var g = (f = {}, f[a] = t, f[o] = n, f[i] = e, f)[m] || 1, _ = this.$d.getTime() + r * g;
				return C.w(_, this);
			}, _.subtract = function(e, t) {
				return this.add(-1 * e, t);
			}, _.format = function(e) {
				var t = this, n = this.$locale();
				if (!this.isValid()) return n.invalidDate || p;
				var r = e || "YYYY-MM-DDTHH:mm:ssZ", i = C.z(this), a = this.$H, o = this.$m, s = this.$M, c = n.weekdays, l = n.months, u = n.meridiem, d = function(e, n, i, a) {
					return e && (e[n] || e(t, r)) || i[n].slice(0, a);
				}, f = function(e) {
					return C.s(a % 12 || 12, e, "0");
				}, m = u || function(e, t, n) {
					var r = e < 12 ? "AM" : "PM";
					return n ? r.toLowerCase() : r;
				};
				return r.replace(h, (function(e, r) {
					return r || function(e) {
						switch (e) {
							case "YY": return String(t.$y).slice(-2);
							case "YYYY": return C.s(t.$y, 4, "0");
							case "M": return s + 1;
							case "MM": return C.s(s + 1, 2, "0");
							case "MMM": return d(n.monthsShort, s, l, 3);
							case "MMMM": return d(l, s);
							case "D": return t.$D;
							case "DD": return C.s(t.$D, 2, "0");
							case "d": return String(t.$W);
							case "dd": return d(n.weekdaysMin, t.$W, c, 2);
							case "ddd": return d(n.weekdaysShort, t.$W, c, 3);
							case "dddd": return c[t.$W];
							case "H": return String(a);
							case "HH": return C.s(a, 2, "0");
							case "h": return f(1);
							case "hh": return f(2);
							case "a": return m(a, o, !0);
							case "A": return m(a, o, !1);
							case "m": return String(o);
							case "mm": return C.s(o, 2, "0");
							case "s": return String(t.$s);
							case "ss": return C.s(t.$s, 2, "0");
							case "SSS": return C.s(t.$ms, 3, "0");
							case "Z": return i;
						}
						return null;
					}(e) || i.replace(":", "");
				}));
			}, _.utcOffset = function() {
				return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
			}, _.diff = function(r, f, p) {
				var m, h = this, g = C.p(f), _ = S(r), v = (_.utcOffset() - this.utcOffset()) * t, y = this - _, b = function() {
					return C.m(h, _);
				};
				switch (g) {
					case d:
						m = b() / 12;
						break;
					case l:
						m = b();
						break;
					case u:
						m = b() / 3;
						break;
					case c:
						m = (y - v) / 6048e5;
						break;
					case s:
						m = (y - v) / 864e5;
						break;
					case o:
						m = y / n;
						break;
					case a:
						m = y / t;
						break;
					case i:
						m = y / e;
						break;
					default: m = y;
				}
				return p ? m : C.a(m);
			}, _.daysInMonth = function() {
				return this.endOf(l).$D;
			}, _.$locale = function() {
				return b[this.$L];
			}, _.locale = function(e, t) {
				if (!e) return this.$L;
				var n = this.clone(), r = te(e, t, !0);
				return r && (n.$L = r), n;
			}, _.clone = function() {
				return C.w(this.$d, this);
			}, _.toDate = function() {
				return new Date(this.valueOf());
			}, _.toJSON = function() {
				return this.isValid() ? this.toISOString() : null;
			}, _.toISOString = function() {
				return this.$d.toISOString();
			}, _.toString = function() {
				return this.$d.toUTCString();
			}, g;
		}(), re = ne.prototype;
		return S.prototype = re, [
			["$ms", r],
			["$s", i],
			["$m", a],
			["$H", o],
			["$W", s],
			["$M", l],
			["$y", d],
			["$D", f]
		].forEach((function(e) {
			re[e[1]] = function(t) {
				return this.$g(t, e[0], e[1]);
			};
		})), S.extend = function(e, t) {
			return e.$i ||= (e(t, ne, S), !0), S;
		}, S.locale = te, S.isDayjs = ee, S.unix = function(e) {
			return S(1e3 * e);
		}, S.en = b[y], S.Ls = b, S.p = {}, S;
	}));
})), di = /* @__PURE__ */ M(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r(ui()) : typeof define == "function" && define.amd ? define(["dayjs"], r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_locale_nl = r(n.dayjs);
	})(e, (function(e) {
		function t(e) {
			return e && typeof e == "object" && "default" in e ? e : { default: e };
		}
		var n = t(e), r = {
			name: "nl",
			weekdays: "zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split("_"),
			weekdaysShort: "zo._ma._di._wo._do._vr._za.".split("_"),
			weekdaysMin: "zo_ma_di_wo_do_vr_za".split("_"),
			months: "januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split("_"),
			monthsShort: "jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec".split("_"),
			ordinal: function(e) {
				return "[" + e + (e === 1 || e === 8 || e >= 20 ? "ste" : "de") + "]";
			},
			weekStart: 1,
			yearStart: 4,
			formats: {
				LT: "HH:mm",
				LTS: "HH:mm:ss",
				L: "DD-MM-YYYY",
				LL: "D MMMM YYYY",
				LLL: "D MMMM YYYY HH:mm",
				LLLL: "dddd D MMMM YYYY HH:mm"
			},
			relativeTime: {
				future: "over %s",
				past: "%s geleden",
				s: "een paar seconden",
				m: "een minuut",
				mm: "%d minuten",
				h: "een uur",
				hh: "%d uur",
				d: "een dag",
				dd: "%d dagen",
				M: "een maand",
				MM: "%d maanden",
				y: "een jaar",
				yy: "%d jaar"
			}
		};
		return n.default.locale(r, null, !0), r;
	}));
})), fi = /* @__PURE__ */ M(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r(ui()) : typeof define == "function" && define.amd ? define(["dayjs"], r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_locale_it = r(n.dayjs);
	})(e, (function(e) {
		function t(e) {
			return e && typeof e == "object" && "default" in e ? e : { default: e };
		}
		var n = t(e), r = {
			name: "it",
			weekdays: "domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato".split("_"),
			weekdaysShort: "dom_lun_mar_mer_gio_ven_sab".split("_"),
			weekdaysMin: "do_lu_ma_me_gi_ve_sa".split("_"),
			months: "gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre".split("_"),
			weekStart: 1,
			monthsShort: "gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic".split("_"),
			formats: {
				LT: "HH:mm",
				LTS: "HH:mm:ss",
				L: "DD/MM/YYYY",
				LL: "D MMMM YYYY",
				LLL: "D MMMM YYYY HH:mm",
				LLLL: "dddd D MMMM YYYY HH:mm"
			},
			relativeTime: {
				future: "tra %s",
				past: "%s fa",
				s: "qualche secondo",
				m: "un minuto",
				mm: "%d minuti",
				h: "un' ora",
				hh: "%d ore",
				d: "un giorno",
				dd: "%d giorni",
				M: "un mese",
				MM: "%d mesi",
				y: "un anno",
				yy: "%d anni"
			},
			ordinal: function(e) {
				return e + "º";
			}
		};
		return n.default.locale(r, null, !0), r;
	}));
})), pi = /* @__PURE__ */ M(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r(ui()) : typeof define == "function" && define.amd ? define(["dayjs"], r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_locale_fr = r(n.dayjs);
	})(e, (function(e) {
		function t(e) {
			return e && typeof e == "object" && "default" in e ? e : { default: e };
		}
		var n = t(e), r = {
			name: "fr",
			weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
			weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
			weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"),
			months: "janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"),
			monthsShort: "janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"),
			weekStart: 1,
			yearStart: 4,
			formats: {
				LT: "HH:mm",
				LTS: "HH:mm:ss",
				L: "DD/MM/YYYY",
				LL: "D MMMM YYYY",
				LLL: "D MMMM YYYY HH:mm",
				LLLL: "dddd D MMMM YYYY HH:mm"
			},
			relativeTime: {
				future: "dans %s",
				past: "il y a %s",
				s: "quelques secondes",
				m: "une minute",
				mm: "%d minutes",
				h: "une heure",
				hh: "%d heures",
				d: "un jour",
				dd: "%d jours",
				M: "un mois",
				MM: "%d mois",
				y: "un an",
				yy: "%d ans"
			},
			ordinal: function(e) {
				return "" + e + (e === 1 ? "er" : "");
			}
		};
		return n.default.locale(r, null, !0), r;
	}));
})), mi = /* @__PURE__ */ M(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_calendar = r();
	})(e, (function() {
		return function(e, t, n) {
			var r = "h:mm A", i = {
				lastDay: "[Yesterday at] " + r,
				sameDay: "[Today at] " + r,
				nextDay: "[Tomorrow at] " + r,
				nextWeek: "dddd [at] " + r,
				lastWeek: "[Last] dddd [at] " + r,
				sameElse: "MM/DD/YYYY"
			};
			t.prototype.calendar = function(e, t) {
				var r = t || this.$locale().calendar || i, a = n(e || void 0).startOf("d"), o = this.diff(a, "d", !0), s = "sameElse", c = o < -6 ? s : o < -1 ? "lastWeek" : o < 0 ? "lastDay" : o < 1 ? "sameDay" : o < 2 ? "nextDay" : o < 7 ? "nextWeek" : s, l = r[c] || i[c];
				return typeof l == "function" ? l.call(this, n()) : this.format(l);
			};
		};
	}));
})), hi = /* @__PURE__ */ M(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_customParseFormat = r();
	})(e, (function() {
		var e = {
			LTS: "h:mm:ss A",
			LT: "h:mm A",
			L: "MM/DD/YYYY",
			LL: "MMMM D, YYYY",
			LLL: "MMMM D, YYYY h:mm A",
			LLLL: "dddd, MMMM D, YYYY h:mm A"
		}, t = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, n = /\d\d/, r = /\d\d?/, i = /\d*[^-_:/,()\s\d]+/, a = {}, o = function(e) {
			return (e = +e) + (e > 68 ? 1900 : 2e3);
		}, s = function(e) {
			return function(t) {
				this[e] = +t;
			};
		}, c = [/[+-]\d\d:?(\d\d)?|Z/, function(e) {
			(this.zone ||= {}).offset = function(e) {
				if (!e || e === "Z") return 0;
				var t = e.match(/([+-]|\d\d)/g), n = 60 * t[1] + (+t[2] || 0);
				return n === 0 ? 0 : t[0] === "+" ? -n : n;
			}(e);
		}], l = function(e) {
			var t = a[e];
			return t && (t.indexOf ? t : t.s.concat(t.f));
		}, u = function(e, t) {
			var n, r = a.meridiem;
			if (r) {
				for (var i = 1; i <= 24; i += 1) if (e.indexOf(r(i, 0, t)) > -1) {
					n = i > 12;
					break;
				}
			} else n = e === (t ? "pm" : "PM");
			return n;
		}, d = {
			A: [i, function(e) {
				this.afternoon = u(e, !1);
			}],
			a: [i, function(e) {
				this.afternoon = u(e, !0);
			}],
			S: [/\d/, function(e) {
				this.milliseconds = 100 * e;
			}],
			SS: [n, function(e) {
				this.milliseconds = 10 * e;
			}],
			SSS: [/\d{3}/, function(e) {
				this.milliseconds = +e;
			}],
			s: [r, s("seconds")],
			ss: [r, s("seconds")],
			m: [r, s("minutes")],
			mm: [r, s("minutes")],
			H: [r, s("hours")],
			h: [r, s("hours")],
			HH: [r, s("hours")],
			hh: [r, s("hours")],
			D: [r, s("day")],
			DD: [n, s("day")],
			Do: [i, function(e) {
				var t = a.ordinal, n = e.match(/\d+/);
				if (this.day = n[0], t) for (var r = 1; r <= 31; r += 1) t(r).replace(/\[|\]/g, "") === e && (this.day = r);
			}],
			M: [r, s("month")],
			MM: [n, s("month")],
			MMM: [i, function(e) {
				var t = l("months"), n = (l("monthsShort") || t.map((function(e) {
					return e.slice(0, 3);
				}))).indexOf(e) + 1;
				if (n < 1) throw Error();
				this.month = n % 12 || n;
			}],
			MMMM: [i, function(e) {
				var t = l("months").indexOf(e) + 1;
				if (t < 1) throw Error();
				this.month = t % 12 || t;
			}],
			Y: [/[+-]?\d+/, s("year")],
			YY: [n, function(e) {
				this.year = o(e);
			}],
			YYYY: [/\d{4}/, s("year")],
			Z: c,
			ZZ: c
		};
		function f(n) {
			for (var r = n, i = a && a.formats, o = (n = r.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, (function(t, n, r) {
				var a = r && r.toUpperCase();
				return n || i[r] || e[r] || i[a].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, (function(e, t, n) {
					return t || n.slice(1);
				}));
			}))).match(t), s = o.length, c = 0; c < s; c += 1) {
				var l = o[c], u = d[l], f = u && u[0], p = u && u[1];
				o[c] = p ? {
					regex: f,
					parser: p
				} : l.replace(/^\[|\]$/g, "");
			}
			return function(e) {
				for (var t = {}, n = 0, r = 0; n < s; n += 1) {
					var i = o[n];
					if (typeof i == "string") r += i.length;
					else {
						var a = i.regex, c = i.parser, l = e.slice(r), u = a.exec(l)[0];
						c.call(t, u), e = e.replace(u, "");
					}
				}
				return function(e) {
					var t = e.afternoon;
					if (t !== void 0) {
						var n = e.hours;
						t ? n < 12 && (e.hours += 12) : n === 12 && (e.hours = 0), delete e.afternoon;
					}
				}(t), t;
			};
		}
		return function(e, t, n) {
			n.p.customParseFormat = !0, e && e.parseTwoDigitYear && (o = e.parseTwoDigitYear);
			var r = t.prototype, i = r.parse;
			r.parse = function(e) {
				var t = e.date, r = e.utc, o = e.args;
				this.$u = r;
				var s = o[1];
				if (typeof s == "string") {
					var c = !0 === o[2], l = !0 === o[3], u = c || l, d = o[2];
					l && (d = o[2]), a = this.$locale(), !c && d && (a = n.Ls[d]), this.$d = function(e, t, n) {
						try {
							if (["x", "X"].indexOf(t) > -1) return /* @__PURE__ */ new Date((t === "X" ? 1e3 : 1) * e);
							var r = f(t)(e), i = r.year, a = r.month, o = r.day, s = r.hours, c = r.minutes, l = r.seconds, u = r.milliseconds, d = r.zone, p = /* @__PURE__ */ new Date(), m = o || (i || a ? 1 : p.getDate()), h = i || p.getFullYear(), g = 0;
							i && !a || (g = a > 0 ? a - 1 : p.getMonth());
							var _ = s || 0, v = c || 0, y = l || 0, b = u || 0;
							return d ? new Date(Date.UTC(h, g, m, _, v, y, b + 60 * d.offset * 1e3)) : n ? new Date(Date.UTC(h, g, m, _, v, y, b)) : new Date(h, g, m, _, v, y, b);
						} catch {
							return /* @__PURE__ */ new Date("");
						}
					}(t, s, r), this.init(), d && !0 !== d && (this.$L = this.locale(d).$L), u && t != this.format(s) && (this.$d = /* @__PURE__ */ new Date("")), a = {};
				} else if (s instanceof Array) for (var p = s.length, m = 1; m <= p; m += 1) {
					o[1] = s[m - 1];
					var h = n.apply(this, o);
					if (h.isValid()) {
						this.$d = h.$d, this.$L = h.$L, this.init();
						break;
					}
					m === p && (this.$d = /* @__PURE__ */ new Date(""));
				}
				else i.call(this, e);
			};
		};
	}));
})), gi = /* @__PURE__ */ M(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_isBetween = r();
	})(e, (function() {
		return function(e, t, n) {
			t.prototype.isBetween = function(e, t, r, i) {
				var a = n(e), o = n(t), s = (i ||= "()")[0] === "(", c = i[1] === ")";
				return (s ? this.isAfter(a, r) : !this.isBefore(a, r)) && (c ? this.isBefore(o, r) : !this.isAfter(o, r)) || (s ? this.isBefore(a, r) : !this.isAfter(a, r)) && (c ? this.isAfter(o, r) : !this.isBefore(o, r));
			};
		};
	}));
})), _i = /* @__PURE__ */ M(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_isLeapYear = r();
	})(e, (function() {
		return function(e, t) {
			t.prototype.isLeapYear = function() {
				return this.$y % 4 == 0 && this.$y % 100 != 0 || this.$y % 400 == 0;
			};
		};
	}));
})), vi = /* @__PURE__ */ M(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_isToday = r();
	})(e, (function() {
		return function(e, t, n) {
			t.prototype.isToday = function() {
				var e = "YYYY-MM-DD", t = n();
				return this.format(e) === t.format(e);
			};
		};
	}));
})), yi = /* @__PURE__ */ M(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_isYesterday = r();
	})(e, (function() {
		return function(e, t, n) {
			t.prototype.isYesterday = function() {
				var e = "YYYY-MM-DD", t = n().subtract(1, "day");
				return this.format(e) === t.format(e);
			};
		};
	}));
})), bi = /* @__PURE__ */ M(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_timezone = r();
	})(e, (function() {
		var e = {
			year: 0,
			month: 1,
			day: 2,
			hour: 3,
			minute: 4,
			second: 5
		}, t = {};
		return function(n, r, i) {
			var a, o = function(e, n, r) {
				r === void 0 && (r = {});
				var i = new Date(e);
				return function(e, n) {
					n === void 0 && (n = {});
					var r = n.timeZoneName || "short", i = e + "|" + r, a = t[i];
					return a || (a = new Intl.DateTimeFormat("en-US", {
						hour12: !1,
						timeZone: e,
						year: "numeric",
						month: "2-digit",
						day: "2-digit",
						hour: "2-digit",
						minute: "2-digit",
						second: "2-digit",
						timeZoneName: r
					}), t[i] = a), a;
				}(n, r).formatToParts(i);
			}, s = function(t, n) {
				for (var r = o(t, n), a = [], s = 0; s < r.length; s += 1) {
					var c = r[s], l = c.type, u = c.value, d = e[l];
					d >= 0 && (a[d] = parseInt(u, 10));
				}
				var f = a[3], p = f === 24 ? 0 : f, m = a[0] + "-" + a[1] + "-" + a[2] + " " + p + ":" + a[4] + ":" + a[5] + ":000", h = +t;
				return (i.utc(m).valueOf() - (h -= h % 1e3)) / 6e4;
			}, c = r.prototype;
			c.tz = function(e, t) {
				e === void 0 && (e = a);
				var n = this.utcOffset(), r = this.toDate(), o = r.toLocaleString("en-US", { timeZone: e }), s = Math.round((r - new Date(o)) / 1e3 / 60), c = i(o, { locale: this.$L }).$set("millisecond", this.$ms).utcOffset(15 * -Math.round(r.getTimezoneOffset() / 15) - s, !0);
				if (t) {
					var l = c.utcOffset();
					c = c.add(n - l, "minute");
				}
				return c.$x.$timezone = e, c;
			}, c.offsetName = function(e) {
				var t = this.$x.$timezone || i.tz.guess(), n = o(this.valueOf(), t, { timeZoneName: e }).find((function(e) {
					return e.type.toLowerCase() === "timezonename";
				}));
				return n && n.value;
			};
			var l = c.startOf;
			c.startOf = function(e, t) {
				if (!this.$x || !this.$x.$timezone) return l.call(this, e, t);
				var n = i(this.format("YYYY-MM-DD HH:mm:ss:SSS"), { locale: this.$L });
				return l.call(n, e, t).tz(this.$x.$timezone, !0);
			}, i.tz = function(e, t, n) {
				var r = n && t, o = n || t || a, c = s(+i(), o);
				if (typeof e != "string") return i(e).tz(o);
				var l = function(e, t, n) {
					var r = e - 60 * t * 1e3, i = s(r, n);
					if (t === i) return [r, t];
					var a = s(r -= 60 * (i - t) * 1e3, n);
					return i === a ? [r, i] : [e - 60 * Math.min(i, a) * 1e3, Math.max(i, a)];
				}(i.utc(e, r).valueOf(), c, o), u = l[0], d = l[1], f = i(u).utcOffset(d);
				return f.$x.$timezone = o, f;
			}, i.tz.guess = function() {
				return Intl.DateTimeFormat().resolvedOptions().timeZone;
			}, i.tz.setDefault = function(e) {
				a = e;
			};
		};
	}));
})), xi = /* @__PURE__ */ M(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_utc = r();
	})(e, (function() {
		var e = "minute", t = /[+-]\d\d(?::?\d\d)?/g, n = /([+-]|\d\d)/g;
		return function(r, i, a) {
			var o = i.prototype;
			a.utc = function(e) {
				return new i({
					date: e,
					utc: !0,
					args: arguments
				});
			}, o.utc = function(t) {
				var n = a(this.toDate(), {
					locale: this.$L,
					utc: !0
				});
				return t ? n.add(this.utcOffset(), e) : n;
			}, o.local = function() {
				return a(this.toDate(), {
					locale: this.$L,
					utc: !1
				});
			};
			var s = o.parse;
			o.parse = function(e) {
				e.utc && (this.$u = !0), this.$utils().u(e.$offset) || (this.$offset = e.$offset), s.call(this, e);
			};
			var c = o.init;
			o.init = function() {
				if (this.$u) {
					var e = this.$d;
					this.$y = e.getUTCFullYear(), this.$M = e.getUTCMonth(), this.$D = e.getUTCDate(), this.$W = e.getUTCDay(), this.$H = e.getUTCHours(), this.$m = e.getUTCMinutes(), this.$s = e.getUTCSeconds(), this.$ms = e.getUTCMilliseconds();
				} else c.call(this);
			};
			var l = o.utcOffset;
			o.utcOffset = function(r, i) {
				var a = this.$utils().u;
				if (a(r)) return this.$u ? 0 : a(this.$offset) ? l.call(this) : this.$offset;
				if (typeof r == "string" && (r = function(e) {
					e === void 0 && (e = "");
					var r = e.match(t);
					if (!r) return null;
					var i = ("" + r[0]).match(n) || [
						"-",
						0,
						0
					], a = i[0], o = 60 * i[1] + +i[2];
					return o === 0 ? 0 : a === "+" ? o : -o;
				}(r), r === null)) return this;
				var o = Math.abs(r) <= 16 ? 60 * r : r, s = this;
				if (i) return s.$offset = o, s.$u = r === 0, s;
				if (r !== 0) {
					var c = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
					(s = this.local().add(o + c, e)).$offset = o, s.$x.$localOffset = c;
				} else s = this.utc();
				return s;
			};
			var u = o.format;
			o.format = function(e) {
				var t = e || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
				return u.call(this, t);
			}, o.valueOf = function() {
				var e = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
				return this.$d.valueOf() - 6e4 * e;
			}, o.isUTC = function() {
				return !!this.$u;
			}, o.toISOString = function() {
				return this.toDate().toISOString();
			}, o.toString = function() {
				return this.toDate().toUTCString();
			};
			var d = o.toDate;
			o.toDate = function(e) {
				return e === "s" && this.$offset ? a(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : d.call(this);
			};
			var f = o.diff;
			o.diff = function(e, t, n) {
				if (e && this.$u === e.$u) return f.call(this, e, t, n);
				var r = this.local(), i = a(e).local();
				return f.call(r, i, t, n);
			};
		};
	}));
}));
di(), fi(), pi();
var Si = /* @__PURE__ */ Wr(ui(), 1), Ci = /* @__PURE__ */ Wr(mi(), 1), wi = /* @__PURE__ */ Wr(hi(), 1), Ti = /* @__PURE__ */ Wr(gi(), 1), Ei = /* @__PURE__ */ Wr(_i(), 1), Di = /* @__PURE__ */ Wr(vi(), 1), Oi = /* @__PURE__ */ Wr(yi(), 1), ki = /* @__PURE__ */ Wr(bi(), 1), Ai = /* @__PURE__ */ Wr(xi(), 1);
Si.default.extend(wi.default), Si.default.extend(Ei.default), Si.default.extend(Ci.default), Si.default.extend(Ai.default), Si.default.extend(Ti.default), Si.default.extend(Di.default), Si.default.extend(Oi.default), Si.default.extend(ki.default), Si.default.locale("nl"), Si.default.tz.setDefault("Europe/Amsterdam");
var ji = Si.default, Mi = (e, { locale: t = "nl-NL", currency: n = "EUR", ...r } = {}) => new Intl.NumberFormat(t, {
	style: "currency",
	currency: n,
	...r
}).format(e / 100), Ni = {
	format: Mi,
	fromMoney: (e) => e ? typeof e.micros == "number" ? e.micros / 1e4 : (e.integral ?? 0) * 100 + (e.fractional ?? 0) : 0,
	rounded: (e) => `${Mi(e, {
		minimumFractionDigits: 0,
		maximumFractionDigits: 0
	})},-`,
	toCents: (e) => Math.round(e * 100),
	toMoney: (e, t) => {
		let n = Math.round(e * 1e4), r = Math.floor(n / 1e4);
		return {
			currency: t ?? "EUR",
			integral: Math.floor(r / 100),
			fractional: r % 100,
			micros: n
		};
	},
	toNumberFromSegments: (e) => {
		if (!e) return 0;
		let t = e?.integral ?? 0, n = e?.fractional ?? 0;
		return t * 100 + n;
	},
	toNumberFromString: (e) => {
		let t = e?.trim() ?? "", n = Math.max(t.lastIndexOf("."), t.lastIndexOf(","));
		if (n >= 0) {
			let e = t.substring(0, n), r = t.substring(n + 1);
			return e = e.replace(/[.,]/g, ""), r.length < 2 ? r = r.padEnd(2, "0") : r.length > 2 && (r = r.substring(0, 2)), parseInt(e + r, 10);
		}
		return parseInt(t.replace(/[.,]/g, ""), 10);
	},
	toSegments: (e) => ({
		integral: Math.floor(e / 100),
		fractional: e % 100
	})
}, Pi = { toCentimeters: (e, t) => {
	switch (t) {
		case Xr.Millimeter:
		case Yr.Millimeter: return e * Zr[Xr.Millimeter];
		case Xr.Centimeter:
		case Yr.Centimeter: return e;
		case Xr.Meter:
		case Yr.Meter: return e * Zr[Xr.Meter];
		default: throw Error(`Unknown unit ${t}`);
	}
} }, Fi = { toBytes: (e) => {
	if (!e) return "0 b";
	let t = 1024, n = [
		"b",
		"kb",
		"mb",
		"gb"
	], r = Math.floor(Math.log(e) / Math.log(t));
	return `${Math.round(e / t ** r * 100) / 100} ${n[r]}`.replace(".", ",");
} }, Ii = {
	toCeiledDecimal: (e, t = 1) => {
		let n = 10 ** t;
		return Math.ceil(e * n) / n;
	},
	toRoundedDecimal: (e, t = 1) => {
		let n = 10 ** t;
		return Math.round(e * n) / n;
	},
	formatCompactNumber: (e) => {
		if (e < 1e3) return String(e);
		let t = e / 1e3;
		return t % 1 == 0 ? `${t}k` : `${t.toFixed(1).replace(/\.0$/, "")}k`;
	}
}, Li = { toTime: (e, t) => ji(e, "HH:mm:ss").format(t) }, Ri = { parseUrlFromDoubleSlashes: (e) => e.replace(/([^:]\/)\/+/g, "$1") }, zi = (e, t) => {
	switch (t) {
		case qr.Gram:
		case Kr.Gram: return e;
		case qr.Kilogram:
		case Kr.Kilogram: return e * Jr[qr.Kilogram];
		default: throw Error(`Unknown unit ${t}`);
	}
}, Bi = (e, t) => {
	switch (t) {
		case Kr.Gram:
		case qr.Gram: return e / Jr[qr.Kilogram];
		case qr.Kilogram:
		case Kr.Kilogram: return e;
		default: throw Error(`Unknown unit ${t}`);
	}
}, Vi = (e, t, n = { round: !0 }) => {
	if (t === Kr.Gram) return `${e}g`;
	if (t === Kr.Kilogram) return `${n.round ? Math.round(e) : e}kg`;
	throw Error(`Unknown unit ${t}`);
}, Hi = {
	currency: Ni,
	dimensions: Pi,
	weight: {
		toGrams: zi,
		toKilograms: Bi,
		toString: Vi,
		toMinMaxString: (e, t, n) => (n === Kr.Kilogram && (e = Bi(e, Kr.Gram), t = Bi(t, Kr.Gram)), `${Vi(e, n)} - ${Vi(t, n)}`)
	},
	time: Li,
	url: Ri,
	fileSize: Fi,
	number: Ii
};
function Ui(e, t, n) {
	let r = t.split(/[.[\]]/).filter(Boolean).reduce((e, t) => e?.[t], e);
	return r === void 0 ? n : r;
}
var Wi = (e, t, n) => {
	let r = t.split("."), i = r.pop(), a = /\[(\d+)\]/, o = e;
	for (let e of r) o = o[e] ??= {};
	let s = i.match(a);
	if (s) {
		let t = Number(s[1]), r = i.replace(a, "");
		return o[r] = Array.isArray(o[r]) ? o[r] : [], o[r][t] = n, e;
	}
	return o[i] = n, e;
}, Gi = (e) => ({ ...e }), Ki = (e, t) => Object.keys(e).reduce((n, r) => (t.includes(r) || (n[r] = e[r]), n), {}), qi = (e) => {
	function t(e, n, r, i = "") {
		let a = [i, n].filter((e) => e).join(".");
		return typeof r == "object" && !Array.isArray(r) ? Object.keys(r).reduce((e, n) => t(e, n, r[n], a), e) : Object.assign(e, { [a]: r });
	}
	return Object.keys(e).reduce((n, r) => t(n, r, e[r]), {});
}, Ji = (e, t) => t.reduce((t, n) => {
	let r = Ui(e, n);
	return r !== void 0 && (t[n] = r), t;
}, {}), Yi = {
	clone: Gi,
	get: Ui,
	pick: Ji,
	pickRename: (e, t) => {
		let n = Ji(e, Object.keys(t));
		return Object.entries(t).reduce((e, [t, r]) => {
			let i = n[t];
			return i !== void 0 && (e[r] = i), e;
		}, {});
	},
	flatten: qi,
	filterKeysFromObject: Ki,
	set: Wi
}, Xi = (e, t) => e.localeCompare(t), Zi = (e, t) => t.localeCompare(e), Qi = (e) => !/^[\p{L}\p{N}]/u.test(e), $i = {
	ascending: Xi,
	descending: Zi,
	byProperty: (e, t = { order: "ASC" }) => (n, r) => {
		let i = Yi.get(n, e), a = Yi.get(r, e), o = t.order === "ASC" ? Xi : Zi;
		if (!i) return t.order === "ASC" ? 1 : -1;
		if (!a) return t.order === "ASC" ? -1 : 1;
		if (t.specialCharactersLast) {
			let e = Qi(i);
			if (e !== Qi(a)) return e ? 1 : -1;
		}
		return o(i, a);
	}
}, ea = {
	byValue: (e = []) => (t, n) => {
		let r = e.indexOf(t), i = e.indexOf(n);
		return r === -1 && i === -1 ? 0 : r === -1 ? 1 : i === -1 ? -1 : r - i;
	},
	byProperty: (e, t = []) => (n, r) => {
		let i = Yi.get(n, e) ?? "", a = Yi.get(r, e) ?? "", o = t.indexOf(i), s = t.indexOf(a);
		return o === -1 && s === -1 ? 0 : o === -1 ? 1 : s === -1 ? -1 : o - s;
	}
}, ta = { sortByDate: (e, t, n = { order: "ASC" }) => e.sort((e, r) => {
	let i = ji(Yi.get(e, t)).unix(), a = ji(Yi.get(r, t)).unix();
	return n.order === "ASC" ? i - a : a - i;
}) }, na = (e, t) => e - t, ra = (e, t) => t - e, ia = {
	numeric: {
		ascending: na,
		descending: ra,
		trailingZero: (e, t) => e === 0 ? 1 : t === 0 ? -1 : e - t,
		byProperty: (e, t = { order: "ASC" }) => (n, r) => {
			let i = Yi.get(n, e), a = Yi.get(r, e);
			if (i === a) return 0;
			let o = t.order === "ASC" ? na : ra;
			return i == null ? t.order === "ASC" ? 1 : -1 : a == null ? t.order === "ASC" ? -1 : 1 : o(i, a);
		}
	},
	alphabetical: $i,
	customOrder: ea,
	date: ta
}, aa = {
	[$.MILLIMETER]: "unit.millimeter.short",
	[$.CENTIMETER]: "unit.centimeter.short",
	[$.DECIMETER]: "unit.decimeter.short",
	[$.METER]: "unit.meter.short",
	[$.KILOMETER]: "unit.kilometer.short",
	[li.GRAM]: "unit.gram.short",
	[li.KILOGRAM]: "unit.kilogram.short"
}, oa = (e) => aa[e], sa = (e) => {
	switch (e) {
		case "g":
		case qr.Gram:
		case Kr.Gram: return Jr[qr.Gram];
		case qr.Kilogram:
		case Kr.Kilogram: return Jr[qr.Kilogram];
		default: throw Error(`Unknown weight unit: ${e}`);
	}
}, ca = {
	[$.MILLIMETER]: 1,
	[$.CENTIMETER]: 10,
	[$.DECIMETER]: 100,
	[$.METER]: 1e3,
	[$.KILOMETER]: 1e6
}, la = ({ value: e, unit: t }, n) => {
	let r = ca[t], i = ca[n];
	return !r || !i ? e : e * r / i;
}, ua = (e) => Object.hasOwn(ca, e), da = ({ value: e, unit: t }) => ua(t) ? la({
	value: e,
	unit: t
}, $.CENTIMETER) : void 0, fa = ({ value: e, unit: t }) => ua(t) ? la({
	value: e,
	unit: t
}, $.METER) : void 0, pa = ({ value: e, unit: t }) => ua(t) ? la({
	value: e,
	unit: t
}, $.MILLIMETER) : void 0, ma = ({ value: e, unit: t }) => ua(t) ? la({
	value: e,
	unit: t
}, $.KILOMETER) : void 0, ha = {
	[li.GRAM]: 1,
	[li.KILOGRAM]: 1e3
}, ga = ({ value: e, unit: t }, n) => {
	let r = ha[t], i = ha[n];
	return !r || !i ? e : e * r / i;
}, _a = (e) => Object.hasOwn(ha, e), va = {
	convertLengthUnit: la,
	convertMassUnit: ga,
	getUnitTranslationKey: oa,
	getWeightFactor: sa,
	isLengthUnit: ua,
	isMassUnit: _a,
	toCentimetres: da,
	toGrams: ({ value: e, unit: t }) => _a(t) ? ga({
		value: e,
		unit: t
	}, li.GRAM) : void 0,
	toKilograms: ({ value: e, unit: t }) => _a(t) ? ga({
		value: e,
		unit: t
	}, li.KILOGRAM) : void 0,
	toKilometres: ma,
	toMetres: fa,
	toMillimetres: pa,
	transformMetersToKilometers: (e) => {
		let t = e / 1e3;
		return t % 1 == 0 ? t : parseFloat(t.toFixed(1));
	}
};
//#endregion
export { o as a, t as c, i, n as l, ia as n, a as o, va as r, e as s, Hi as t, r as u };
